/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ActivityItem {
    'id': string;
    'timestamp': string;
    'type': string;
    'user'?: ActivityUserRef | null;
    'track'?: ActivityTrackRef | null;
    'details'?: { [key: string]: any; };
}
export interface ActivityTrackRef {
    'id': number;
    'name'?: string | null;
}
export interface ActivityUserRef {
    'id'?: number | null;
    'display_name'?: string | null;
}
export interface AdminOverview {
    'active_users_24h': number;
    'total_tracks': number;
    'tracks_today': number;
    'total_waypoints': number;
    'waypoints_today': number;
    'storage_used_bytes': number;
    'processing_queue_count': number;
    'last_updated': string;
}
export interface AdminStorageItem {
    'id': number;
    'owner_user_id': number;
    'object_key': string;
    'original_filename': string;
    'mime_type': string;
    'file_size_bytes': number;
    'is_public': boolean;
    'context'?: string | null;
    'download_count': number;
    'created_at': string;
}
export interface AdminStorageResponse {
    'total': number;
    'items': Array<AdminStorageItem>;
}
export interface AdminTrackItem {
    'id': number;
    'name': string;
    'owner_id': number;
    'visibility': string;
    'track_type'?: string | null;
    'created_at': string;
    'waypoint_count': number;
    'collaborator_count': number;
}
export interface AdminTracksResponse {
    'total': number;
    'items': Array<AdminTrackItem>;
}
export interface AdminUserItem {
    'id': number;
    'email': string;
    'display_name': string | null;
    'trust_level': string;
    'created_at': string;
    'last_active_at'?: string | null;
    'track_count': number;
    'waypoint_count': number;
    'storage_used_bytes': number;
}
export interface AdminUsersResponse {
    'total': number;
    'items': Array<AdminUserItem>;
}
export interface AnalyticsSeriesPoint {
    'date': string;
    'users': number;
    'tracks': number;
    'waypoints': number;
}
export interface AnalyticsStoragePoint {
    'date': string;
    'storage': number;
}
export interface AnalyticsTrackTypeItem {
    'name': string;
    'value': number;
    'color': string;
}
export interface AnalyticsUsage {
    'series': Array<AnalyticsSeriesPoint>;
    'trackTypes': Array<AnalyticsTrackTypeItem>;
    'storage': Array<AnalyticsStoragePoint>;
}
export interface AudioGenRequest {
    'prompt': string;
    'link_id'?: string | null;
    'owner_user_id'?: number | null;
    'duration_ms'?: number | null;
}
export interface AuthResponse {
    'user_id': number;
    'access_token': string;
    'api_key': string;
    'trust_level': string;
    'expires_in'?: number;
}
export interface ChunkCompleteRequest {
    'upload_id': string;
}
export interface ChunkInitRequest {
    'waypoint_id': number;
    'media_type': string;
    'size_bytes': number;
    'metadata_json'?: { [key: string]: any; } | null;
}
export interface ChunkInitResponse {
    'upload_id': string;
}
export interface CleanupByAgeRequest {
    'days': number;
}
export interface CleanupByCollectionRequest {
    'collection_id': string;
}
export interface CleanupByUserRequest {
    'email': string;
}
export interface CleanupResponse {
    'deleted_count': number;
    'message': string;
}
export interface CollectionInfo {
    'id': string;
    'name': string | null;
    'item_count': number;
    'owner_email'?: string | null;
}
export interface DepthJobRequest {
    'image': string;
}
export interface ElevenLabsTTSConfig {
    /**
     * The model to use, e.g., \'eleven_multilingual_v2\'
     */
    'model_id'?: string;
    /**
     * The ID of the voice to use
     */
    'voice_id'?: string;
    /**
     * Voice stability, from 0.0 to 1.0
     */
    'stability'?: number;
    /**
     * Voice clarity/similarity, from 0.0 to 1.0
     */
    'clarity'?: number;
}
export interface ErrorLog {
    'id': number;
    'timestamp'?: string | null;
    'level': string;
    'message': string;
    'endpoint'?: string | null;
}
export interface GPSPointBatchCreate {
    'trackId': number;
    'points': Array<GPSPointCreate>;
    'batchId': string;
}
export interface GPSPointBatchResponse {
    'batchId': string;
    'trackId': number;
    'pointsCreated': number;
    'pointsSkipped': number;
    'processingTimeMs': number;
}
export interface GPSPointCreate {
    'trackId': number;
    'latitude': number;
    'longitude': number;
    'altitude'?: number | null;
    'accuracy': number;
    'timestamp': string;
    'speed'?: number | null;
    'course'?: number | null;
    'isFromKalmanFilter'?: boolean;
    'segmentId'?: number | null;
    'connectionQuality'?: string | null;
}
export interface GPSPointResponse {
    'id': number;
    'trackId': number;
    'latitude': number;
    'longitude': number;
    'altitude': number | null;
    'accuracy': number;
    'timestamp': string;
    'speed': number | null;
    'course': number | null;
    'isFromKalmanFilter': boolean;
    'createdAt': string;
}
export interface GPSTrackStatsResponse {
    'trackId': number;
    'totalPoints': number;
    'totalDistance': number;
    'trackDuration': number;
    'averageSpeed': number;
    'maxSpeed': number | null;
    'minAltitude': number | null;
    'maxAltitude': number | null;
    'startTime': string | null;
    'endTime': string | null;
}
export interface GoogleAuthRequest {
    'id_token': string;
    'device_id'?: string | null;
    'display_name'?: string | null;
}
export interface HTTPValidationError {
    'detail'?: Array<ValidationError>;
}
export interface ImageGenRequest {
    'prompt': string;
    'link_id'?: string | null;
    'owner_user_id'?: number | null;
    'collection_id'?: string | null;
}
export interface LogCreate {
    /**
     * debug|info|warning|error|critical
     */
    'level'?: string;
    'message': string;
    'app_name'?: string | null;
    'tags'?: Array<string> | null;
    'metadata_json'?: { [key: string]: any; } | null;
    'device_id'?: string | null;
    'platform'?: string | null;
    'build'?: string | null;
    'request_id'?: string | null;
}
export interface LogResponse {
    'id': number;
    'created_at': string;
    'level': string;
    'message': string;
    'app_name'?: string | null;
    'tags'?: Array<string> | null;
    'metadata_json'?: { [key: string]: any; } | null;
    'device_id'?: string | null;
    'platform'?: string | null;
    'build'?: string | null;
    'request_id'?: string | null;
    'created_by'?: number | null;
}
export interface MediaAnalysis {
    'description': string;
    'categories': Array<string>;
    'safety_rating': string;
    'quality_score': number;
    'confidence': number;
}
export interface MediaFileResponse {
    'media_id': number;
    'type': string;
    'processing_state': string;
    'analysis'?: MediaAnalysis | null;
    'thumbnail_url'?: string | null;
    'url'?: string | null;
    'storage_object_id'?: number | null;
}
export interface MediaUploadUrl {
    'media_slot': number;
    'upload_url': string;
    'max_size_bytes': number;
}
export interface MessageResponse {
    'message': string;
}
export interface ModerationQueueItem {
    'id': number;
    'track_id': number;
    'recorded_at': string;
    'processing_state'?: string | null;
    'moderation_status'?: string | null;
}
export interface ModerationQueueResponse {
    'total': number;
    'items': Array<ModerationQueueItem>;
}
export interface ModerationResult {
    'status': string;
    'waypoint_id': number;
    'action': string;
    'reason'?: string | null;
}
export interface OpenAITTSConfig {
    /**
     * The model to use, e.g., \'tts-1\' or \'tts-1-hd\'
     */
    'model'?: string;
    /**
     * The voice to use for the audio
     */
    'voice'?: OpenAITTSConfigVoiceEnum;
    /**
     * The speaking rate, from 0.25 to 4.0
     */
    'speed'?: number;
    /**
     * The output format for the audio
     */
    'output_format'?: OpenAITTSConfigOutputFormatEnum;
}

export const OpenAITTSConfigVoiceEnum = {
    Alloy: 'alloy',
    Echo: 'echo',
    Fable: 'fable',
    Onyx: 'onyx',
    Nova: 'nova',
    Shimmer: 'shimmer'
} as const;

export type OpenAITTSConfigVoiceEnum = typeof OpenAITTSConfigVoiceEnum[keyof typeof OpenAITTSConfigVoiceEnum];
export const OpenAITTSConfigOutputFormatEnum = {
    Mp3: 'mp3',
    Opus: 'opus',
    Aac: 'aac',
    Flac: 'flac'
} as const;

export type OpenAITTSConfigOutputFormatEnum = typeof OpenAITTSConfigOutputFormatEnum[keyof typeof OpenAITTSConfigOutputFormatEnum];

export interface PerformanceMetrics {
    'avg_response_time'?: number | null;
    'uptime_percentage'?: number | null;
    'error_rate'?: number | null;
    'requests_per_hour'?: number | null;
}
export interface Prompt {
    'text': string;
    'images'?: Array<string> | null;
    'audio'?: string | null;
    'video'?: string | null;
}
export interface QuotaInfo {
    'storage_bytes': number;
    'storage_limit': number;
    'uploads_this_month': number;
    'upload_limit': number;
}
export interface RemoteFetchRequest {
    'url': string;
    'context'?: string | null;
    'is_public'?: boolean;
    'owner_email'?: string | null;
    'collection_id'?: string | null;
    'link_id'?: string | null;
    'filename'?: string | null;
    'analyze'?: boolean;
}
export interface SegmentEndRequest {
    'ended_at'?: string | null;
}
export interface SegmentEndResponse {
    'segment_id': number;
    'ended_at': string;
}
export interface SegmentItem {
    'id': number;
    'started_at': string;
    'ended_at': string | null;
    'points': number;
    'distance_m': number;
}
export interface SegmentStartRequest {
    'name'?: string | null;
}
export interface SegmentStartResponse {
    'segment_id': number;
    'started_at': string;
}
export interface ServiceStatusResponse {
    'service': string;
    'component': string | null;
    'current_status': string;
    'last_update': string;
    'message': string;
    'uptime_percentage': number;
    'recent_alerts': Array<LogResponse>;
    'metadata'?: { [key: string]: any; } | null;
}
export interface SimpleUserRef {
    'id'?: number | null;
    'display_name'?: string | null;
}
export interface SpeechRequest {
    'id': string;
    'type'?: string;
    'timestamp': string;
    'content': TTSContent;
    'config': TTSConfig;
    'save_options'?: { [key: string]: any; } | null;
    'collection_id'?: string | null;
}
export interface StorageListResponse {
    'items': Array<StorageObjectResponse>;
}
export interface StorageObjectResponse {
    'id': number;
    'owner_user_id'?: number | null;
    'owner_email'?: string | null;
    'object_key': string;
    'original_filename': string;
    'file_url': string;
    'thumbnail_url'?: string | null;
    'webview_url'?: string | null;
    'mime_type': string;
    'file_size_bytes': number;
    'checksum': string;
    'is_public': boolean;
    'context'?: string | null;
    'collection_id'?: string | null;
    'link_id'?: string | null;
    'title'?: string | null;
    'description'?: string | null;
    'likes'?: number;
    'width'?: number | null;
    'height'?: number | null;
    'duration_seconds'?: number | null;
    'bit_rate'?: number | null;
    'ai_safety_rating'?: string | null;
    'metadata_json'?: { [key: string]: any; };
    'download_count'?: number;
    'created_at': string;
    'updated_at': string;
    'ai_category'?: string | null;
    'ai_danger_potential'?: number | null;
    'hls_url'?: string | null;
    'transcoding_status'?: string | null;
    'transcoding_progress'?: number | null;
    'transcoding_error'?: string | null;
    'transcoded_file_size_bytes'?: number | null;
    'ai_safety_status'?: string | null;
    'ai_safety_error'?: string | null;
    'ai_title'?: string | null;
    'ai_subtitle'?: string | null;
    'ai_tags'?: Array<string> | null;
    'ai_collections'?: Array<string> | null;
    'safety_info'?: { [key: string]: any; } | null;
}
export interface StorageObjectUpdate {
    'is_public'?: boolean | null;
    'context'?: string | null;
    'collection_id'?: string | null;
    'link_id'?: string | null;
    'title'?: string | null;
    'description'?: string | null;
    'ai_safety_rating'?: string | null;
    'metadata_json'?: { [key: string]: any; } | null;
    'original_filename'?: string | null;
    'ai_title'?: string | null;
    'ai_subtitle'?: string | null;
    'ai_tags'?: Array<any> | null;
    'ai_collections'?: Array<any> | null;
    'safety_info'?: { [key: string]: any; } | null;
}
export interface SyncStatus {
    'user_id': number;
    'last_sync_at': string;
    'pending_uploads': number;
    'pending_analysis': number;
    'failed_uploads': number;
    'quota_used': QuotaInfo;
}
export interface SystemAlert {
    /**
     * Service name (e.g., \'tunnel\', \'transcoding\', \'storage\', \'api\')
     */
    'service': string;
    'component'?: string | null;
    /**
     * healthy|warning|critical|down|recovering
     */
    'status': string;
    'message': string;
    /**
     * debug|info|warning|error|critical
     */
    'severity'?: string;
    'timestamp'?: string | null;
    'metadata'?: { [key: string]: any; } | null;
    'escalation_policy'?: string | null;
}
export interface SystemHealth {
    'db_ok': boolean;
    'storage_ok': boolean;
    'ai_services_ok': boolean;
    'time': string;
}
export interface TTSConfig {
    'provider'?: string;
    'output_format'?: string;
    'openai'?: OpenAITTSConfig | null;
    'elevenlabs'?: ElevenLabsTTSConfig | null;
    'voice_mapping'?: { [key: string]: string; } | null;
    'dialog_mode'?: boolean;
    'ai_gender'?: TTSConfigAiGenderEnum;
    'narrator_gender'?: TTSConfigNarratorGenderEnum | null;
    'analysis_user_hint'?: string | null;
    'analysis_override'?: { [key: string]: any; } | null;
    'generate_title_image'?: boolean;
    'add_sfx'?: boolean;
    'add_music'?: boolean;
    'manual_music_storage_id'?: string | null;
    'music_loop'?: boolean;
    'music_stop_at_end'?: boolean;
    'analyze_only'?: boolean;
}

export const TTSConfigAiGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;

export type TTSConfigAiGenderEnum = typeof TTSConfigAiGenderEnum[keyof typeof TTSConfigAiGenderEnum];
export const TTSConfigNarratorGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;

export type TTSConfigNarratorGenderEnum = typeof TTSConfigNarratorGenderEnum[keyof typeof TTSConfigNarratorGenderEnum];

export interface TTSContent {
    'text': string;
    'language'?: string;
    'voice'?: string;
    'pitch'?: number;
    'speed'?: number;
    'stability'?: number | null;
    'clarity'?: number | null;
    'style'?: string | null;
}
export interface TrackCreate {
    'name': string;
    'description'?: string;
    'visibility'?: Visibility;
    'track_type'?: string;
    'tags'?: Array<string>;
    'client_track_id': string;
}


export interface TrackResponse {
    'id': number;
    'name': string;
    'description': string;
    'visibility': string;
    'track_type': string;
    'tags': Array<string>;
    'client_track_id': string;
    'stats': TrackStats;
    'created_at': string;
    'updated_at': string;
}
export interface TrackStats {
    'total_waypoints': number;
    'processed_waypoints': number;
    'pending_analysis': number;
    'distance_meters': number;
    'duration_seconds': number;
}
export interface TransferOwnerByLinkRequest {
    'link_id': string;
    'owner_email': string;
}
export interface UploadSession {
    'session_id': string;
    'media_upload_urls': Array<MediaUploadUrl>;
    'expires_at': string;
}
export interface UpscaleRequest {
    'image_b64'?: string | null;
    'image_url'?: string | null;
    'output_format'?: string | null;
    'link_id'?: string | null;
    'owner_user_id'?: number | null;
}
export interface UserCreate {
    'email': string;
    'password': string;
    'display_name': string;
    'device_id': string;
}
export interface UserLogin {
    'email': string;
    'password': string;
    'device_id': string;
}
export interface UserResponse {
    'id': number;
    'email': string;
    'display_name': string;
    'trust_level': string;
    'created_at': string;
}
export interface UserWithCollections {
    'email': string;
    'display_name': string;
    'collection_count': number;
}
export interface ValidationError {
    'loc': Array<ValidationErrorLocInner>;
    'msg': string;
    'type': string;
}
export interface ValidationErrorLocInner {
}

export const Visibility = {
    Public: 'public',
    Followers: 'followers',
    Private: 'private'
} as const;

export type Visibility = typeof Visibility[keyof typeof Visibility];


export interface WaypointBatch {
    'waypoints': Array<WaypointCreate>;
}
export interface WaypointBatchResponse {
    'results': Array<WaypointCreateResponse>;
}
export interface WaypointCreate {
    'client_waypoint_id': string;
    'latitude': number;
    'longitude': number;
    'altitude'?: number | null;
    'accuracy'?: number | null;
    'recorded_at': string;
    'user_description'?: string;
    'media_count'?: number;
    'waypoint_type'?: string | null;
    'metadata_json'?: { [key: string]: any; } | null;
    'segment_id'?: number | null;
}
export interface WaypointCreateResponse {
    'client_waypoint_id': string;
    'waypoint_id': number;
    'status': string;
    'upload_session'?: UploadSession | null;
}
export interface WaypointDetailResponse {
    'id': number;
    'track_id': number;
    'latitude': number;
    'longitude': number;
    'altitude'?: number | null;
    'accuracy'?: number | null;
    'recorded_at': string;
    'user_description'?: string | null;
    'processing_state'?: string | null;
    'moderation_status'?: string | null;
    'waypoint_type'?: string | null;
    'metadata_json'?: { [key: string]: any; } | null;
    'segment_id'?: number | null;
    'media'?: Array<MediaFileResponse>;
}
export interface WaypointListItem {
    'waypoint_id': number;
    'processing_state': string;
    'media': Array<MediaFileResponse>;
    'moderation_status': string;
    'published_at'?: string | null;
    'metadata_json'?: { [key: string]: any; } | null;
    'track_id': number;
    'track_name'?: string | null;
    'creator_id'?: number | null;
    'creator'?: SimpleUserRef | null;
    'location'?: WaypointLocation | null;
    'created_at'?: string | null;
    'media_count'?: number | null;
    'waypoint_type'?: string | null;
    'segment_id'?: number | null;
}
export interface WaypointLocation {
    'latitude': number;
    'longitude': number;
}
export interface WaypointStatusResponse {
    'waypoint_id': number;
    'processing_state': string;
    'media': Array<MediaFileResponse>;
    'moderation_status': string;
    'published_at'?: string | null;
    'metadata_json'?: { [key: string]: any; } | null;
}
export interface WaypointUpdate {
    'title'?: string | null;
    'description'?: string | null;
    'tags'?: Array<string> | null;
}

/**
 * ArtrackAdminApi - axios parameter creator
 */
export const ArtrackAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return a mixed feed of recent activities (waypoints, tracks, users).
         * @summary Admin Activity Feed
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActivityFeedArtrackAdminActivityFeedGet: async (limit?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/activity/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return performance metrics. If unavailable, return null values so UI shows N/A.
         * @summary Admin Analytics Performance
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/analytics/performance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return usage analytics series and breakdowns for charts.  Response shape: {   \"series\": [ { \"date\": \"YYYY-MM-DD\", \"users\": int, \"tracks\": int, \"waypoints\": int } ],   \"trackTypes\": [ { \"name\": str, \"value\": int, \"color\": str } ],   \"storage\": [ { \"date\": \"YYYY-MM-DD\", \"storage\": float } ]  # GB }
         * @summary Admin Analytics Usage
         * @param {string} [timeframe] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAnalyticsUsageArtrackAdminAnalyticsUsageGet: async (timeframe?: string, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/analytics/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeframe !== undefined) {
                localVarQueryParameter['timeframe'] = timeframe;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a track as admin (bypasses ownership).
         * @summary Admin Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteTrackArtrackAdminTracksTrackIdDelete: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('adminDeleteTrackArtrackAdminTracksTrackIdDelete', 'trackId', trackId)
            const localVarPath = `/artrack/admin/tracks/{track_id}`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return recent error/warning log lines from api.log if present.
         * @summary Admin Logs Errors
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogsErrorsArtrackAdminLogsErrorsGet: async (limit?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/logs/errors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Moderate Waypoint
         * @param {number} waypointId 
         * @param {string} action 
         * @param {string | null} [reason] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost: async (waypointId: number, action: string, reason?: string | null, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost', 'waypointId', waypointId)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost', 'action', action)
            const localVarPath = `/artrack/admin/waypoints/{waypoint_id}/moderate`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Moderation Queue
         * @param {string} [status] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModerationQueueArtrackAdminWaypointsModerationGet: async (status?: string, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/waypoints/moderation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Overview Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOverviewStatsArtrackAdminStatsOverviewGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/stats/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a storage object and its file (admin-only). Also cancels Mac transcoding if active.
         * @summary Admin Storage Delete
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStorageDeleteArtrackAdminStorageObjectIdDelete: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('adminStorageDeleteArtrackAdminStorageObjectIdDelete', 'objectId', objectId)
            const localVarPath = `/artrack/admin/storage/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List stored files across all users for administration.
         * @summary Admin Storage List
         * @param {string | null} [q] 
         * @param {number | null} [ownerId] 
         * @param {string | null} [context] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStorageListArtrackAdminStorageGet: async (q?: string | null, ownerId?: number | null, context?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['owner_id'] = ownerId;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin System Health
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSystemHealthArtrackAdminSystemHealthGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/system/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Tracks
         * @param {string | null} [visibility] 
         * @param {string | null} [trackType] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTracksArtrackAdminTracksGet: async (visibility?: string | null, trackType?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/tracks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }

            if (trackType !== undefined) {
                localVarQueryParameter['track_type'] = trackType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Users
         * @param {string | null} [q] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersArtrackAdminUsersGet: async (q?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackAdminApi - functional programming interface
 */
export const ArtrackAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Return a mixed feed of recent activities (waypoints, tracks, users).
         * @summary Admin Activity Feed
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminActivityFeedArtrackAdminActivityFeedGet(limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminActivityFeedArtrackAdminActivityFeedGet(limit, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminActivityFeedArtrackAdminActivityFeedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return performance metrics. If unavailable, return null values so UI shows N/A.
         * @summary Admin Analytics Performance
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PerformanceMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return usage analytics series and breakdowns for charts.  Response shape: {   \"series\": [ { \"date\": \"YYYY-MM-DD\", \"users\": int, \"tracks\": int, \"waypoints\": int } ],   \"trackTypes\": [ { \"name\": str, \"value\": int, \"color\": str } ],   \"storage\": [ { \"date\": \"YYYY-MM-DD\", \"storage\": float } ]  # GB }
         * @summary Admin Analytics Usage
         * @param {string} [timeframe] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAnalyticsUsageArtrackAdminAnalyticsUsageGet(timeframe?: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsUsage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAnalyticsUsageArtrackAdminAnalyticsUsageGet(timeframe, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminAnalyticsUsageArtrackAdminAnalyticsUsageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a track as admin (bypasses ownership).
         * @summary Admin Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteTrackArtrackAdminTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteTrackArtrackAdminTracksTrackIdDelete(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminDeleteTrackArtrackAdminTracksTrackIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return recent error/warning log lines from api.log if present.
         * @summary Admin Logs Errors
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLogsErrorsArtrackAdminLogsErrorsGet(limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ErrorLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLogsErrorsArtrackAdminLogsErrorsGet(limit, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminLogsErrorsArtrackAdminLogsErrorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Moderate Waypoint
         * @param {number} waypointId 
         * @param {string} action 
         * @param {string | null} [reason] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost(waypointId: number, action: string, reason?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModerationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost(waypointId, action, reason, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Moderation Queue
         * @param {string} [status] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminModerationQueueArtrackAdminWaypointsModerationGet(status?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModerationQueueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminModerationQueueArtrackAdminWaypointsModerationGet(status, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminModerationQueueArtrackAdminWaypointsModerationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Overview Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOverviewStatsArtrackAdminStatsOverviewGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOverviewStatsArtrackAdminStatsOverviewGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminOverviewStatsArtrackAdminStatsOverviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a storage object and its file (admin-only). Also cancels Mac transcoding if active.
         * @summary Admin Storage Delete
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStorageDeleteArtrackAdminStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStorageDeleteArtrackAdminStorageObjectIdDelete(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminStorageDeleteArtrackAdminStorageObjectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List stored files across all users for administration.
         * @summary Admin Storage List
         * @param {string | null} [q] 
         * @param {number | null} [ownerId] 
         * @param {string | null} [context] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStorageListArtrackAdminStorageGet(q?: string | null, ownerId?: number | null, context?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminStorageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStorageListArtrackAdminStorageGet(q, ownerId, context, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminStorageListArtrackAdminStorageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin System Health
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSystemHealthArtrackAdminSystemHealthGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemHealth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSystemHealthArtrackAdminSystemHealthGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminSystemHealthArtrackAdminSystemHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Tracks
         * @param {string | null} [visibility] 
         * @param {string | null} [trackType] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTracksArtrackAdminTracksGet(visibility?: string | null, trackType?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTracksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTracksArtrackAdminTracksGet(visibility, trackType, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminTracksArtrackAdminTracksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Users
         * @param {string | null} [q] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersArtrackAdminUsersGet(q?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersArtrackAdminUsersGet(q, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAdminApi.adminUsersArtrackAdminUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackAdminApi - factory interface
 */
export const ArtrackAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackAdminApiFp(configuration)
    return {
        /**
         * Return a mixed feed of recent activities (waypoints, tracks, users).
         * @summary Admin Activity Feed
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActivityFeedArtrackAdminActivityFeedGet(limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActivityItem>> {
            return localVarFp.adminActivityFeedArtrackAdminActivityFeedGet(limit, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Return performance metrics. If unavailable, return null values so UI shows N/A.
         * @summary Admin Analytics Performance
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<PerformanceMetrics> {
            return localVarFp.adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Return usage analytics series and breakdowns for charts.  Response shape: {   \"series\": [ { \"date\": \"YYYY-MM-DD\", \"users\": int, \"tracks\": int, \"waypoints\": int } ],   \"trackTypes\": [ { \"name\": str, \"value\": int, \"color\": str } ],   \"storage\": [ { \"date\": \"YYYY-MM-DD\", \"storage\": float } ]  # GB }
         * @summary Admin Analytics Usage
         * @param {string} [timeframe] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAnalyticsUsageArtrackAdminAnalyticsUsageGet(timeframe?: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<AnalyticsUsage> {
            return localVarFp.adminAnalyticsUsageArtrackAdminAnalyticsUsageGet(timeframe, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a track as admin (bypasses ownership).
         * @summary Admin Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteTrackArtrackAdminTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.adminDeleteTrackArtrackAdminTracksTrackIdDelete(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Return recent error/warning log lines from api.log if present.
         * @summary Admin Logs Errors
         * @param {number} [limit] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogsErrorsArtrackAdminLogsErrorsGet(limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ErrorLog>> {
            return localVarFp.adminLogsErrorsArtrackAdminLogsErrorsGet(limit, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Moderate Waypoint
         * @param {number} waypointId 
         * @param {string} action 
         * @param {string | null} [reason] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost(waypointId: number, action: string, reason?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<ModerationResult> {
            return localVarFp.adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost(waypointId, action, reason, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Moderation Queue
         * @param {string} [status] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminModerationQueueArtrackAdminWaypointsModerationGet(status?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<ModerationQueueResponse> {
            return localVarFp.adminModerationQueueArtrackAdminWaypointsModerationGet(status, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Overview Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOverviewStatsArtrackAdminStatsOverviewGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminOverview> {
            return localVarFp.adminOverviewStatsArtrackAdminStatsOverviewGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a storage object and its file (admin-only). Also cancels Mac transcoding if active.
         * @summary Admin Storage Delete
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStorageDeleteArtrackAdminStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.adminStorageDeleteArtrackAdminStorageObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * List stored files across all users for administration.
         * @summary Admin Storage List
         * @param {string | null} [q] 
         * @param {number | null} [ownerId] 
         * @param {string | null} [context] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStorageListArtrackAdminStorageGet(q?: string | null, ownerId?: number | null, context?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminStorageResponse> {
            return localVarFp.adminStorageListArtrackAdminStorageGet(q, ownerId, context, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin System Health
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSystemHealthArtrackAdminSystemHealthGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<SystemHealth> {
            return localVarFp.adminSystemHealthArtrackAdminSystemHealthGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Tracks
         * @param {string | null} [visibility] 
         * @param {string | null} [trackType] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTracksArtrackAdminTracksGet(visibility?: string | null, trackType?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminTracksResponse> {
            return localVarFp.adminTracksArtrackAdminTracksGet(visibility, trackType, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Users
         * @param {string | null} [q] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersArtrackAdminUsersGet(q?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminUsersResponse> {
            return localVarFp.adminUsersArtrackAdminUsersGet(q, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackAdminApi - object-oriented interface
 */
export class ArtrackAdminApi extends BaseAPI {
    /**
     * Return a mixed feed of recent activities (waypoints, tracks, users).
     * @summary Admin Activity Feed
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminActivityFeedArtrackAdminActivityFeedGet(limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminActivityFeedArtrackAdminActivityFeedGet(limit, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return performance metrics. If unavailable, return null values so UI shows N/A.
     * @summary Admin Analytics Performance
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminAnalyticsPerformanceArtrackAdminAnalyticsPerformanceGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return usage analytics series and breakdowns for charts.  Response shape: {   \"series\": [ { \"date\": \"YYYY-MM-DD\", \"users\": int, \"tracks\": int, \"waypoints\": int } ],   \"trackTypes\": [ { \"name\": str, \"value\": int, \"color\": str } ],   \"storage\": [ { \"date\": \"YYYY-MM-DD\", \"storage\": float } ]  # GB }
     * @summary Admin Analytics Usage
     * @param {string} [timeframe] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminAnalyticsUsageArtrackAdminAnalyticsUsageGet(timeframe?: string, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminAnalyticsUsageArtrackAdminAnalyticsUsageGet(timeframe, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a track as admin (bypasses ownership).
     * @summary Admin Delete Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDeleteTrackArtrackAdminTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminDeleteTrackArtrackAdminTracksTrackIdDelete(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return recent error/warning log lines from api.log if present.
     * @summary Admin Logs Errors
     * @param {number} [limit] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLogsErrorsArtrackAdminLogsErrorsGet(limit?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminLogsErrorsArtrackAdminLogsErrorsGet(limit, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Moderate Waypoint
     * @param {number} waypointId 
     * @param {string} action 
     * @param {string | null} [reason] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost(waypointId: number, action: string, reason?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminModerateWaypointArtrackAdminWaypointsWaypointIdModeratePost(waypointId, action, reason, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Moderation Queue
     * @param {string} [status] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminModerationQueueArtrackAdminWaypointsModerationGet(status?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminModerationQueueArtrackAdminWaypointsModerationGet(status, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Overview Stats
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminOverviewStatsArtrackAdminStatsOverviewGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminOverviewStatsArtrackAdminStatsOverviewGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a storage object and its file (admin-only). Also cancels Mac transcoding if active.
     * @summary Admin Storage Delete
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminStorageDeleteArtrackAdminStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminStorageDeleteArtrackAdminStorageObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List stored files across all users for administration.
     * @summary Admin Storage List
     * @param {string | null} [q] 
     * @param {number | null} [ownerId] 
     * @param {string | null} [context] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminStorageListArtrackAdminStorageGet(q?: string | null, ownerId?: number | null, context?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminStorageListArtrackAdminStorageGet(q, ownerId, context, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin System Health
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminSystemHealthArtrackAdminSystemHealthGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminSystemHealthArtrackAdminSystemHealthGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Tracks
     * @param {string | null} [visibility] 
     * @param {string | null} [trackType] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTracksArtrackAdminTracksGet(visibility?: string | null, trackType?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminTracksArtrackAdminTracksGet(visibility, trackType, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Users
     * @param {string | null} [q] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminUsersArtrackAdminUsersGet(q?: string | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAdminApiFp(this.configuration).adminUsersArtrackAdminUsersGet(q, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtrackAuthApi - axios parameter creator
 */
export const ArtrackAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current user info
         * @summary Get Me
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeArtrackAuthMeGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Login/Register via Firebase Google ID token and return api_key.
         * @summary Google Login
         * @param {GoogleAuthRequest} googleAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLoginArtrackAuthGooglePost: async (googleAuthRequest: GoogleAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleAuthRequest' is not null or undefined
            assertParamExists('googleLoginArtrackAuthGooglePost', 'googleAuthRequest', googleAuthRequest)
            const localVarPath = `/artrack/auth/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Login user
         * @summary Login
         * @param {UserLogin} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginArtrackAuthLoginPost: async (userLogin: UserLogin, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userLogin' is not null or undefined
            assertParamExists('loginArtrackAuthLoginPost', 'userLogin', userLogin)
            const localVarPath = `/artrack/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userLogin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh access token (placeholder - in real app would use refresh token)
         * @summary Refresh Token
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenArtrackAuthRefreshPost: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a new user
         * @summary Register
         * @param {UserCreate} userCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerArtrackAuthRegisterPost: async (userCreate: UserCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreate' is not null or undefined
            assertParamExists('registerArtrackAuthRegisterPost', 'userCreate', userCreate)
            const localVarPath = `/artrack/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackAuthApi - functional programming interface
 */
export const ArtrackAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current user info
         * @summary Get Me
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeArtrackAuthMeGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeArtrackAuthMeGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAuthApi.getMeArtrackAuthMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Login/Register via Firebase Google ID token and return api_key.
         * @summary Google Login
         * @param {GoogleAuthRequest} googleAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLoginArtrackAuthGooglePost(googleAuthRequest: GoogleAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleLoginArtrackAuthGooglePost(googleAuthRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAuthApi.googleLoginArtrackAuthGooglePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Login user
         * @summary Login
         * @param {UserLogin} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginArtrackAuthLoginPost(userLogin: UserLogin, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginArtrackAuthLoginPost(userLogin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAuthApi.loginArtrackAuthLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refresh access token (placeholder - in real app would use refresh token)
         * @summary Refresh Token
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokenArtrackAuthRefreshPost(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokenArtrackAuthRefreshPost(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAuthApi.refreshTokenArtrackAuthRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register a new user
         * @summary Register
         * @param {UserCreate} userCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerArtrackAuthRegisterPost(userCreate: UserCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerArtrackAuthRegisterPost(userCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackAuthApi.registerArtrackAuthRegisterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackAuthApi - factory interface
 */
export const ArtrackAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackAuthApiFp(configuration)
    return {
        /**
         * Get current user info
         * @summary Get Me
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeArtrackAuthMeGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.getMeArtrackAuthMeGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Login/Register via Firebase Google ID token and return api_key.
         * @summary Google Login
         * @param {GoogleAuthRequest} googleAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLoginArtrackAuthGooglePost(googleAuthRequest: GoogleAuthRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.googleLoginArtrackAuthGooglePost(googleAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Login user
         * @summary Login
         * @param {UserLogin} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginArtrackAuthLoginPost(userLogin: UserLogin, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.loginArtrackAuthLoginPost(userLogin, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh access token (placeholder - in real app would use refresh token)
         * @summary Refresh Token
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenArtrackAuthRefreshPost(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.refreshTokenArtrackAuthRefreshPost(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a new user
         * @summary Register
         * @param {UserCreate} userCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerArtrackAuthRegisterPost(userCreate: UserCreate, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.registerArtrackAuthRegisterPost(userCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackAuthApi - object-oriented interface
 */
export class ArtrackAuthApi extends BaseAPI {
    /**
     * Get current user info
     * @summary Get Me
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMeArtrackAuthMeGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAuthApiFp(this.configuration).getMeArtrackAuthMeGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Login/Register via Firebase Google ID token and return api_key.
     * @summary Google Login
     * @param {GoogleAuthRequest} googleAuthRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public googleLoginArtrackAuthGooglePost(googleAuthRequest: GoogleAuthRequest, options?: RawAxiosRequestConfig) {
        return ArtrackAuthApiFp(this.configuration).googleLoginArtrackAuthGooglePost(googleAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Login user
     * @summary Login
     * @param {UserLogin} userLogin 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public loginArtrackAuthLoginPost(userLogin: UserLogin, options?: RawAxiosRequestConfig) {
        return ArtrackAuthApiFp(this.configuration).loginArtrackAuthLoginPost(userLogin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh access token (placeholder - in real app would use refresh token)
     * @summary Refresh Token
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshTokenArtrackAuthRefreshPost(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackAuthApiFp(this.configuration).refreshTokenArtrackAuthRefreshPost(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a new user
     * @summary Register
     * @param {UserCreate} userCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerArtrackAuthRegisterPost(userCreate: UserCreate, options?: RawAxiosRequestConfig) {
        return ArtrackAuthApiFp(this.configuration).registerArtrackAuthRegisterPost(userCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtrackGpsApi - axios parameter creator
 */
export const ArtrackGpsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Clear all GPS points for a track (owner only)
         * @summary Clear Gps Points
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearGpsPointsArtrackTracksTrackIdGpsPointsDelete: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('clearGpsPointsArtrackTracksTrackIdGpsPointsDelete', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}/gps-points`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a single GPS point for real-time tracking
         * @summary Create Gps Point
         * @param {number} trackId 
         * @param {GPSPointCreate} gPSPointCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGpsPointArtrackTracksTrackIdGpsPointsPost: async (trackId: number, gPSPointCreate: GPSPointCreate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('createGpsPointArtrackTracksTrackIdGpsPointsPost', 'trackId', trackId)
            // verify required parameter 'gPSPointCreate' is not null or undefined
            assertParamExists('createGpsPointArtrackTracksTrackIdGpsPointsPost', 'gPSPointCreate', gPSPointCreate)
            const localVarPath = `/artrack/tracks/{track_id}/gps-points`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gPSPointCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create multiple GPS points in a batch for efficient sync
         * @summary Create Gps Point Batch
         * @param {number} trackId 
         * @param {GPSPointBatchCreate} gPSPointBatchCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost: async (trackId: number, gPSPointBatchCreate: GPSPointBatchCreate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost', 'trackId', trackId)
            // verify required parameter 'gPSPointBatchCreate' is not null or undefined
            assertParamExists('createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost', 'gPSPointBatchCreate', gPSPointBatchCreate)
            const localVarPath = `/artrack/tracks/{track_id}/gps-points/batch`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gPSPointBatchCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the processing status of a GPS point batch
         * @summary Get Batch Processing Status
         * @param {string} batchId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet: async (batchId: string, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet', 'batchId', batchId)
            const localVarPath = `/artrack/tracks/batch-status/{batch_id}`
                .replace(`{${"batch_id"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get GPS track points for a track
         * @summary Get Gps Points
         * @param {number} trackId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {number | null} [segmentId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGpsPointsArtrackTracksTrackIdGpsPointsGet: async (trackId: number, limit?: number, offset?: number, segmentId?: number | null, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('getGpsPointsArtrackTracksTrackIdGpsPointsGet', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}/gps-points`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (segmentId !== undefined) {
                localVarQueryParameter['segment_id'] = segmentId;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get comprehensive GPS track statistics
         * @summary Get Gps Track Statistics
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}/gps-stats`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackGpsApi - functional programming interface
 */
export const ArtrackGpsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackGpsApiAxiosParamCreator(configuration)
    return {
        /**
         * Clear all GPS points for a track (owner only)
         * @summary Clear Gps Points
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearGpsPointsArtrackTracksTrackIdGpsPointsDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearGpsPointsArtrackTracksTrackIdGpsPointsDelete(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackGpsApi.clearGpsPointsArtrackTracksTrackIdGpsPointsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a single GPS point for real-time tracking
         * @summary Create Gps Point
         * @param {number} trackId 
         * @param {GPSPointCreate} gPSPointCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGpsPointArtrackTracksTrackIdGpsPointsPost(trackId: number, gPSPointCreate: GPSPointCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GPSPointResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGpsPointArtrackTracksTrackIdGpsPointsPost(trackId, gPSPointCreate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackGpsApi.createGpsPointArtrackTracksTrackIdGpsPointsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create multiple GPS points in a batch for efficient sync
         * @summary Create Gps Point Batch
         * @param {number} trackId 
         * @param {GPSPointBatchCreate} gPSPointBatchCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost(trackId: number, gPSPointBatchCreate: GPSPointBatchCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GPSPointBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost(trackId, gPSPointBatchCreate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackGpsApi.createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the processing status of a GPS point batch
         * @summary Get Batch Processing Status
         * @param {string} batchId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet(batchId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet(batchId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackGpsApi.getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get GPS track points for a track
         * @summary Get Gps Points
         * @param {number} trackId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {number | null} [segmentId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGpsPointsArtrackTracksTrackIdGpsPointsGet(trackId: number, limit?: number, offset?: number, segmentId?: number | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GPSPointResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGpsPointsArtrackTracksTrackIdGpsPointsGet(trackId, limit, offset, segmentId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackGpsApi.getGpsPointsArtrackTracksTrackIdGpsPointsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get comprehensive GPS track statistics
         * @summary Get Gps Track Statistics
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GPSTrackStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackGpsApi.getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackGpsApi - factory interface
 */
export const ArtrackGpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackGpsApiFp(configuration)
    return {
        /**
         * Clear all GPS points for a track (owner only)
         * @summary Clear Gps Points
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearGpsPointsArtrackTracksTrackIdGpsPointsDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.clearGpsPointsArtrackTracksTrackIdGpsPointsDelete(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a single GPS point for real-time tracking
         * @summary Create Gps Point
         * @param {number} trackId 
         * @param {GPSPointCreate} gPSPointCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGpsPointArtrackTracksTrackIdGpsPointsPost(trackId: number, gPSPointCreate: GPSPointCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<GPSPointResponse> {
            return localVarFp.createGpsPointArtrackTracksTrackIdGpsPointsPost(trackId, gPSPointCreate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Create multiple GPS points in a batch for efficient sync
         * @summary Create Gps Point Batch
         * @param {number} trackId 
         * @param {GPSPointBatchCreate} gPSPointBatchCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost(trackId: number, gPSPointBatchCreate: GPSPointBatchCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<GPSPointBatchResponse> {
            return localVarFp.createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost(trackId, gPSPointBatchCreate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the processing status of a GPS point batch
         * @summary Get Batch Processing Status
         * @param {string} batchId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet(batchId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet(batchId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get GPS track points for a track
         * @summary Get Gps Points
         * @param {number} trackId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {number | null} [segmentId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGpsPointsArtrackTracksTrackIdGpsPointsGet(trackId: number, limit?: number, offset?: number, segmentId?: number | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GPSPointResponse>> {
            return localVarFp.getGpsPointsArtrackTracksTrackIdGpsPointsGet(trackId, limit, offset, segmentId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get comprehensive GPS track statistics
         * @summary Get Gps Track Statistics
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<GPSTrackStatsResponse> {
            return localVarFp.getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackGpsApi - object-oriented interface
 */
export class ArtrackGpsApi extends BaseAPI {
    /**
     * Clear all GPS points for a track (owner only)
     * @summary Clear Gps Points
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public clearGpsPointsArtrackTracksTrackIdGpsPointsDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackGpsApiFp(this.configuration).clearGpsPointsArtrackTracksTrackIdGpsPointsDelete(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a single GPS point for real-time tracking
     * @summary Create Gps Point
     * @param {number} trackId 
     * @param {GPSPointCreate} gPSPointCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGpsPointArtrackTracksTrackIdGpsPointsPost(trackId: number, gPSPointCreate: GPSPointCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackGpsApiFp(this.configuration).createGpsPointArtrackTracksTrackIdGpsPointsPost(trackId, gPSPointCreate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create multiple GPS points in a batch for efficient sync
     * @summary Create Gps Point Batch
     * @param {number} trackId 
     * @param {GPSPointBatchCreate} gPSPointBatchCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost(trackId: number, gPSPointBatchCreate: GPSPointBatchCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackGpsApiFp(this.configuration).createGpsPointBatchArtrackTracksTrackIdGpsPointsBatchPost(trackId, gPSPointBatchCreate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the processing status of a GPS point batch
     * @summary Get Batch Processing Status
     * @param {string} batchId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet(batchId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackGpsApiFp(this.configuration).getBatchProcessingStatusArtrackTracksBatchStatusBatchIdGet(batchId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get GPS track points for a track
     * @summary Get Gps Points
     * @param {number} trackId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number | null} [segmentId] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGpsPointsArtrackTracksTrackIdGpsPointsGet(trackId: number, limit?: number, offset?: number, segmentId?: number | null, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackGpsApiFp(this.configuration).getGpsPointsArtrackTracksTrackIdGpsPointsGet(trackId, limit, offset, segmentId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get comprehensive GPS track statistics
     * @summary Get Gps Track Statistics
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackGpsApiFp(this.configuration).getGpsTrackStatisticsArtrackTracksTrackIdGpsStatsGet(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtrackGuideApi - axios parameter creator
 */
export const ArtrackGuideApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Build iOS Guide JSON from a track\'s waypoints.  Body params (optional):   - siteId, siteName, description   - voice: { provider, style, speed, pitch, language }   - audioSettings: { crossfadeDuration, maxNarrationLength, volumeNormalization,                     continuousNarration, continuousInterval, ambientGuide, ambientInterval,                     poiAwareness, poiAwarenessDistance, poiAwarenessInterval }   - defaultRadius (meters)   - enterMultiplier, exitMultiplier, cooldownSeconds   - persona, backgroundMusic
         * @summary Build Guide From Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {{ [key: string]: any; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildGuideFromTrackArtrackTrackIdGuidePost: async (trackId: number, xAPIKEY?: string, requestBody?: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('buildGuideFromTrackArtrackTrackIdGuidePost', 'trackId', trackId)
            const localVarPath = `/artrack/{track_id}/guide`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackGuideApi - functional programming interface
 */
export const ArtrackGuideApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackGuideApiAxiosParamCreator(configuration)
    return {
        /**
         * Build iOS Guide JSON from a track\'s waypoints.  Body params (optional):   - siteId, siteName, description   - voice: { provider, style, speed, pitch, language }   - audioSettings: { crossfadeDuration, maxNarrationLength, volumeNormalization,                     continuousNarration, continuousInterval, ambientGuide, ambientInterval,                     poiAwareness, poiAwarenessDistance, poiAwarenessInterval }   - defaultRadius (meters)   - enterMultiplier, exitMultiplier, cooldownSeconds   - persona, backgroundMusic
         * @summary Build Guide From Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {{ [key: string]: any; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildGuideFromTrackArtrackTrackIdGuidePost(trackId: number, xAPIKEY?: string, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildGuideFromTrackArtrackTrackIdGuidePost(trackId, xAPIKEY, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackGuideApi.buildGuideFromTrackArtrackTrackIdGuidePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackGuideApi - factory interface
 */
export const ArtrackGuideApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackGuideApiFp(configuration)
    return {
        /**
         * Build iOS Guide JSON from a track\'s waypoints.  Body params (optional):   - siteId, siteName, description   - voice: { provider, style, speed, pitch, language }   - audioSettings: { crossfadeDuration, maxNarrationLength, volumeNormalization,                     continuousNarration, continuousInterval, ambientGuide, ambientInterval,                     poiAwareness, poiAwarenessDistance, poiAwarenessInterval }   - defaultRadius (meters)   - enterMultiplier, exitMultiplier, cooldownSeconds   - persona, backgroundMusic
         * @summary Build Guide From Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {{ [key: string]: any; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildGuideFromTrackArtrackTrackIdGuidePost(trackId: number, xAPIKEY?: string, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.buildGuideFromTrackArtrackTrackIdGuidePost(trackId, xAPIKEY, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackGuideApi - object-oriented interface
 */
export class ArtrackGuideApi extends BaseAPI {
    /**
     * Build iOS Guide JSON from a track\'s waypoints.  Body params (optional):   - siteId, siteName, description   - voice: { provider, style, speed, pitch, language }   - audioSettings: { crossfadeDuration, maxNarrationLength, volumeNormalization,                     continuousNarration, continuousInterval, ambientGuide, ambientInterval,                     poiAwareness, poiAwarenessDistance, poiAwarenessInterval }   - defaultRadius (meters)   - enterMultiplier, exitMultiplier, cooldownSeconds   - persona, backgroundMusic
     * @summary Build Guide From Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildGuideFromTrackArtrackTrackIdGuidePost(trackId: number, xAPIKEY?: string, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig) {
        return ArtrackGuideApiFp(this.configuration).buildGuideFromTrackArtrackTrackIdGuidePost(trackId, xAPIKEY, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtrackSegmentsApi - axios parameter creator
 */
export const ArtrackSegmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary End Segment
         * @param {number} trackId 
         * @param {number} segmentId 
         * @param {SegmentEndRequest} segmentEndRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost: async (trackId: number, segmentId: number, segmentEndRequest: SegmentEndRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost', 'trackId', trackId)
            // verify required parameter 'segmentId' is not null or undefined
            assertParamExists('endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost', 'segmentId', segmentId)
            // verify required parameter 'segmentEndRequest' is not null or undefined
            assertParamExists('endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost', 'segmentEndRequest', segmentEndRequest)
            const localVarPath = `/artrack/tracks/{track_id}/segments/{segment_id}/end`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)))
                .replace(`{${"segment_id"}}`, encodeURIComponent(String(segmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(segmentEndRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Segments
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSegmentsArtrackTracksTrackIdSegmentsGet: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('listSegmentsArtrackTracksTrackIdSegmentsGet', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}/segments`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start Segment
         * @param {number} trackId 
         * @param {SegmentStartRequest} segmentStartRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSegmentArtrackTracksTrackIdSegmentsStartPost: async (trackId: number, segmentStartRequest: SegmentStartRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('startSegmentArtrackTracksTrackIdSegmentsStartPost', 'trackId', trackId)
            // verify required parameter 'segmentStartRequest' is not null or undefined
            assertParamExists('startSegmentArtrackTracksTrackIdSegmentsStartPost', 'segmentStartRequest', segmentStartRequest)
            const localVarPath = `/artrack/tracks/{track_id}/segments/start`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(segmentStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackSegmentsApi - functional programming interface
 */
export const ArtrackSegmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackSegmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary End Segment
         * @param {number} trackId 
         * @param {number} segmentId 
         * @param {SegmentEndRequest} segmentEndRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost(trackId: number, segmentId: number, segmentEndRequest: SegmentEndRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentEndResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost(trackId, segmentId, segmentEndRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSegmentsApi.endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Segments
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSegmentsArtrackTracksTrackIdSegmentsGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SegmentItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSegmentsArtrackTracksTrackIdSegmentsGet(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSegmentsApi.listSegmentsArtrackTracksTrackIdSegmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start Segment
         * @param {number} trackId 
         * @param {SegmentStartRequest} segmentStartRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSegmentArtrackTracksTrackIdSegmentsStartPost(trackId: number, segmentStartRequest: SegmentStartRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SegmentStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSegmentArtrackTracksTrackIdSegmentsStartPost(trackId, segmentStartRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSegmentsApi.startSegmentArtrackTracksTrackIdSegmentsStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackSegmentsApi - factory interface
 */
export const ArtrackSegmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackSegmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary End Segment
         * @param {number} trackId 
         * @param {number} segmentId 
         * @param {SegmentEndRequest} segmentEndRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost(trackId: number, segmentId: number, segmentEndRequest: SegmentEndRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<SegmentEndResponse> {
            return localVarFp.endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost(trackId, segmentId, segmentEndRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Segments
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSegmentsArtrackTracksTrackIdSegmentsGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SegmentItem>> {
            return localVarFp.listSegmentsArtrackTracksTrackIdSegmentsGet(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start Segment
         * @param {number} trackId 
         * @param {SegmentStartRequest} segmentStartRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSegmentArtrackTracksTrackIdSegmentsStartPost(trackId: number, segmentStartRequest: SegmentStartRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<SegmentStartResponse> {
            return localVarFp.startSegmentArtrackTracksTrackIdSegmentsStartPost(trackId, segmentStartRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackSegmentsApi - object-oriented interface
 */
export class ArtrackSegmentsApi extends BaseAPI {
    /**
     * 
     * @summary End Segment
     * @param {number} trackId 
     * @param {number} segmentId 
     * @param {SegmentEndRequest} segmentEndRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost(trackId: number, segmentId: number, segmentEndRequest: SegmentEndRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackSegmentsApiFp(this.configuration).endSegmentArtrackTracksTrackIdSegmentsSegmentIdEndPost(trackId, segmentId, segmentEndRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Segments
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSegmentsArtrackTracksTrackIdSegmentsGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackSegmentsApiFp(this.configuration).listSegmentsArtrackTracksTrackIdSegmentsGet(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start Segment
     * @param {number} trackId 
     * @param {SegmentStartRequest} segmentStartRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startSegmentArtrackTracksTrackIdSegmentsStartPost(trackId: number, segmentStartRequest: SegmentStartRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackSegmentsApiFp(this.configuration).startSegmentArtrackTracksTrackIdSegmentsStartPost(trackId, segmentStartRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtrackSyncApi - axios parameter creator
 */
export const ArtrackSyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Clean up failed uploads and orphaned data
         * @summary Cleanup Failed Data
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanupFailedDataArtrackSyncCleanupPost: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/sync/cleanup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sync status for current user
         * @summary Get Sync Status
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncStatusArtrackSyncStatusGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/sync/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed user statistics
         * @summary Get User Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStatsArtrackSyncUserStatsGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/sync/user-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Health check endpoint
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckArtrackSyncHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/sync/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry failed uploads
         * @summary Retry Failed Uploads
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedUploadsArtrackSyncRetryFailedPost: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/sync/retry-failed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackSyncApi - functional programming interface
 */
export const ArtrackSyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackSyncApiAxiosParamCreator(configuration)
    return {
        /**
         * Clean up failed uploads and orphaned data
         * @summary Cleanup Failed Data
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanupFailedDataArtrackSyncCleanupPost(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanupFailedDataArtrackSyncCleanupPost(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSyncApi.cleanupFailedDataArtrackSyncCleanupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get sync status for current user
         * @summary Get Sync Status
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyncStatusArtrackSyncStatusGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyncStatusArtrackSyncStatusGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSyncApi.getSyncStatusArtrackSyncStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed user statistics
         * @summary Get User Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserStatsArtrackSyncUserStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserStatsArtrackSyncUserStatsGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSyncApi.getUserStatsArtrackSyncUserStatsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Health check endpoint
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckArtrackSyncHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckArtrackSyncHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSyncApi.healthCheckArtrackSyncHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry failed uploads
         * @summary Retry Failed Uploads
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryFailedUploadsArtrackSyncRetryFailedPost(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryFailedUploadsArtrackSyncRetryFailedPost(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackSyncApi.retryFailedUploadsArtrackSyncRetryFailedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackSyncApi - factory interface
 */
export const ArtrackSyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackSyncApiFp(configuration)
    return {
        /**
         * Clean up failed uploads and orphaned data
         * @summary Cleanup Failed Data
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanupFailedDataArtrackSyncCleanupPost(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.cleanupFailedDataArtrackSyncCleanupPost(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sync status for current user
         * @summary Get Sync Status
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncStatusArtrackSyncStatusGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncStatus> {
            return localVarFp.getSyncStatusArtrackSyncStatusGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed user statistics
         * @summary Get User Stats
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStatsArtrackSyncUserStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUserStatsArtrackSyncUserStatsGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Health check endpoint
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckArtrackSyncHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckArtrackSyncHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retry failed uploads
         * @summary Retry Failed Uploads
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryFailedUploadsArtrackSyncRetryFailedPost(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.retryFailedUploadsArtrackSyncRetryFailedPost(xAPIKEY, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackSyncApi - object-oriented interface
 */
export class ArtrackSyncApi extends BaseAPI {
    /**
     * Clean up failed uploads and orphaned data
     * @summary Cleanup Failed Data
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cleanupFailedDataArtrackSyncCleanupPost(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackSyncApiFp(this.configuration).cleanupFailedDataArtrackSyncCleanupPost(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sync status for current user
     * @summary Get Sync Status
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSyncStatusArtrackSyncStatusGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackSyncApiFp(this.configuration).getSyncStatusArtrackSyncStatusGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed user statistics
     * @summary Get User Stats
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserStatsArtrackSyncUserStatsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackSyncApiFp(this.configuration).getUserStatsArtrackSyncUserStatsGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Health check endpoint
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthCheckArtrackSyncHealthGet(options?: RawAxiosRequestConfig) {
        return ArtrackSyncApiFp(this.configuration).healthCheckArtrackSyncHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry failed uploads
     * @summary Retry Failed Uploads
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryFailedUploadsArtrackSyncRetryFailedPost(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackSyncApiFp(this.configuration).retryFailedUploadsArtrackSyncRetryFailedPost(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtrackTracksApi - axios parameter creator
 */
export const ArtrackTracksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new track
         * @summary Create Track
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrackArtrackTracksPost: async (trackCreate: TrackCreate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackCreate' is not null or undefined
            assertParamExists('createTrackArtrackTracksPost', 'trackCreate', trackCreate)
            const localVarPath = `/artrack/tracks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a track
         * @summary Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrackArtrackTracksTrackIdDelete: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('deleteTrackArtrackTracksTrackIdDelete', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get track details
         * @summary Get Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackArtrackTracksTrackIdGet: async (trackId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('getTrackArtrackTracksTrackIdGet', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List tracks
         * @summary List Tracks
         * @param {string} [visibility] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTracksArtrackTracksGet: async (visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/tracks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a track
         * @summary Update Track
         * @param {number} trackId 
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackArtrackTracksTrackIdPut: async (trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('updateTrackArtrackTracksTrackIdPut', 'trackId', trackId)
            // verify required parameter 'trackCreate' is not null or undefined
            assertParamExists('updateTrackArtrackTracksTrackIdPut', 'trackCreate', trackCreate)
            const localVarPath = `/artrack/tracks/{track_id}`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackTracksApi - functional programming interface
 */
export const ArtrackTracksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackTracksApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new track
         * @summary Create Track
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrackArtrackTracksPost(trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrackArtrackTracksPost(trackCreate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.createTrackArtrackTracksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a track
         * @summary Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrackArtrackTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrackArtrackTracksTrackIdDelete(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.deleteTrackArtrackTracksTrackIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get track details
         * @summary Get Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackArtrackTracksTrackIdGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackArtrackTracksTrackIdGet(trackId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.getTrackArtrackTracksTrackIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List tracks
         * @summary List Tracks
         * @param {string} [visibility] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTracksArtrackTracksGet(visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTracksArtrackTracksGet(visibility, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.listTracksArtrackTracksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a track
         * @summary Update Track
         * @param {number} trackId 
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrackArtrackTracksTrackIdPut(trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrackArtrackTracksTrackIdPut(trackId, trackCreate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackTracksApi.updateTrackArtrackTracksTrackIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackTracksApi - factory interface
 */
export const ArtrackTracksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackTracksApiFp(configuration)
    return {
        /**
         * Create a new track
         * @summary Create Track
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrackArtrackTracksPost(trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse> {
            return localVarFp.createTrackArtrackTracksPost(trackCreate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a track
         * @summary Delete Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrackArtrackTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteTrackArtrackTracksTrackIdDelete(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get track details
         * @summary Get Track
         * @param {number} trackId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackArtrackTracksTrackIdGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<TrackResponse> {
            return localVarFp.getTrackArtrackTracksTrackIdGet(trackId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * List tracks
         * @summary List Tracks
         * @param {string} [visibility] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTracksArtrackTracksGet(visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TrackResponse>> {
            return localVarFp.listTracksArtrackTracksGet(visibility, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a track
         * @summary Update Track
         * @param {number} trackId 
         * @param {TrackCreate} trackCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrackArtrackTracksTrackIdPut(trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateTrackArtrackTracksTrackIdPut(trackId, trackCreate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackTracksApi - object-oriented interface
 */
export class ArtrackTracksApi extends BaseAPI {
    /**
     * Create a new track
     * @summary Create Track
     * @param {TrackCreate} trackCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTrackArtrackTracksPost(trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).createTrackArtrackTracksPost(trackCreate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a track
     * @summary Delete Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTrackArtrackTracksTrackIdDelete(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).deleteTrackArtrackTracksTrackIdDelete(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get track details
     * @summary Get Track
     * @param {number} trackId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTrackArtrackTracksTrackIdGet(trackId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).getTrackArtrackTracksTrackIdGet(trackId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List tracks
     * @summary List Tracks
     * @param {string} [visibility] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTracksArtrackTracksGet(visibility?: string, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).listTracksArtrackTracksGet(visibility, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a track
     * @summary Update Track
     * @param {number} trackId 
     * @param {TrackCreate} trackCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTrackArtrackTracksTrackIdPut(trackId: number, trackCreate: TrackCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackTracksApiFp(this.configuration).updateTrackArtrackTracksTrackIdPut(trackId, trackCreate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtrackWaypointsApi - axios parameter creator
 */
export const ArtrackWaypointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Complete Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkCompleteRequest} chunkCompleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost: async (sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost', 'mediaSlot', mediaSlot)
            // verify required parameter 'chunkCompleteRequest' is not null or undefined
            assertParamExists('completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost', 'chunkCompleteRequest', chunkCompleteRequest)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}/complete-chunked`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chunkCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete upload session and finalize waypoint
         * @summary Complete Upload Session
         * @param {string} sessionId 
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUploadSessionArtrackUploadSessionIdCompletePost: async (sessionId: string, waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('completeUploadSessionArtrackUploadSessionIdCompletePost', 'sessionId', sessionId)
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('completeUploadSessionArtrackUploadSessionIdCompletePost', 'waypointId', waypointId)
            const localVarPath = `/artrack/upload/{session_id}/complete`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (waypointId !== undefined) { 
                localVarFormParams.set('waypoint_id', waypointId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create waypoints for a track
         * @summary Create Waypoints
         * @param {number} trackId 
         * @param {WaypointBatch} waypointBatch 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaypointsArtrackTrackIdWaypointsPost: async (trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('createWaypointsArtrackTrackIdWaypointsPost', 'trackId', trackId)
            // verify required parameter 'waypointBatch' is not null or undefined
            assertParamExists('createWaypointsArtrackTrackIdWaypointsPost', 'waypointBatch', waypointBatch)
            const localVarPath = `/artrack/{track_id}/waypoints`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waypointBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Waypoint
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaypointArtrackWaypointsWaypointIdDelete: async (waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('deleteWaypointArtrackWaypointsWaypointIdDelete', 'waypointId', waypointId)
            const localVarPath = `/artrack/waypoints/{waypoint_id}`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Waypoint Detail
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointDetailArtrackWaypointsWaypointIdGet: async (waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('getWaypointDetailArtrackWaypointsWaypointIdGet', 'waypointId', waypointId)
            const localVarPath = `/artrack/waypoints/{waypoint_id}`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get waypoint processing status
         * @summary Get Waypoint Status
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointStatusArtrackWaypointsWaypointIdStatusGet: async (waypointId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('getWaypointStatusArtrackWaypointsWaypointIdStatusGet', 'waypointId', waypointId)
            const localVarPath = `/artrack/waypoints/{waypoint_id}/status`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Init Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkInitRequest} chunkInitRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost: async (sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost', 'mediaSlot', mediaSlot)
            // verify required parameter 'chunkInitRequest' is not null or undefined
            assertParamExists('initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost', 'chunkInitRequest', chunkInitRequest)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}/init`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chunkInitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List waypoints
         * @summary List Waypoints
         * @param {number} [trackId] 
         * @param {number} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsArtrackWaypointsGet: async (trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/waypoints/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (trackId !== undefined) {
                localVarQueryParameter['track_id'] = trackId;
            }

            if (segmentId !== undefined) {
                localVarQueryParameter['segment_id'] = segmentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return full waypoint details for a given track (coords, times, media summary).
         * @summary List Waypoints Detail
         * @param {number} trackId 
         * @param {number | null} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet: async (trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackId' is not null or undefined
            assertParamExists('listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet', 'trackId', trackId)
            const localVarPath = `/artrack/tracks/{track_id}/waypoints/detail`
                .replace(`{${"track_id"}}`, encodeURIComponent(String(trackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (segmentId !== undefined) {
                localVarQueryParameter['segment_id'] = segmentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Waypoint
         * @param {number} waypointId 
         * @param {WaypointUpdate} waypointUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaypointArtrackWaypointsWaypointIdPut: async (waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('updateWaypointArtrackWaypointsWaypointIdPut', 'waypointId', waypointId)
            // verify required parameter 'waypointUpdate' is not null or undefined
            assertParamExists('updateWaypointArtrackWaypointsWaypointIdPut', 'waypointUpdate', waypointUpdate)
            const localVarPath = `/artrack/waypoints/{waypoint_id}`
                .replace(`{${"waypoint_id"}}`, encodeURIComponent(String(waypointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waypointUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Chunk Part
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {number} index 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut: async (sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'mediaSlot', mediaSlot)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'index', index)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut', 'file', file)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}/parts/{index}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload media file for a waypoint
         * @summary Upload Media File
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {File} file 
         * @param {number} waypointId 
         * @param {string} mediaType 
         * @param {string | null} [xContentHash] 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [metadataJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMediaFileArtrackUploadSessionIdMediaSlotPost: async (sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'sessionId', sessionId)
            // verify required parameter 'mediaSlot' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'mediaSlot', mediaSlot)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'file', file)
            // verify required parameter 'waypointId' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'waypointId', waypointId)
            // verify required parameter 'mediaType' is not null or undefined
            assertParamExists('uploadMediaFileArtrackUploadSessionIdMediaSlotPost', 'mediaType', mediaType)
            const localVarPath = `/artrack/upload/{session_id}/{media_slot}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"media_slot"}}`, encodeURIComponent(String(mediaSlot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (waypointId !== undefined) { 
                localVarFormParams.append('waypoint_id', waypointId as any);
            }
    
            if (mediaType !== undefined) { 
                localVarFormParams.append('media_type', mediaType as any);
            }
    
            if (metadataJson !== undefined) { 
                localVarFormParams.append('metadata_json', metadataJson as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xContentHash != null) {
                localVarHeaderParameter['X-Content-Hash'] = String(xContentHash);
            }
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtrackWaypointsApi - functional programming interface
 */
export const ArtrackWaypointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtrackWaypointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Complete Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkCompleteRequest} chunkCompleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId, mediaSlot, chunkCompleteRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete upload session and finalize waypoint
         * @summary Complete Upload Session
         * @param {string} sessionId 
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId: string, waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId, waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.completeUploadSessionArtrackUploadSessionIdCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create waypoints for a track
         * @summary Create Waypoints
         * @param {number} trackId 
         * @param {WaypointBatch} waypointBatch 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWaypointsArtrackTrackIdWaypointsPost(trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaypointBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWaypointsArtrackTrackIdWaypointsPost(trackId, waypointBatch, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.createWaypointsArtrackTrackIdWaypointsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Waypoint
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.deleteWaypointArtrackWaypointsWaypointIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Waypoint Detail
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaypointDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.getWaypointDetailArtrackWaypointsWaypointIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get waypoint processing status
         * @summary Get Waypoint Status
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaypointStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.getWaypointStatusArtrackWaypointsWaypointIdStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Init Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkInitRequest} chunkInitRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChunkInitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId, mediaSlot, chunkInitRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List waypoints
         * @summary List Waypoints
         * @param {number} [trackId] 
         * @param {number} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWaypointsArtrackWaypointsGet(trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaypointListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWaypointsArtrackWaypointsGet(trackId, segmentId, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.listWaypointsArtrackWaypointsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return full waypoint details for a given track (coords, times, media summary).
         * @summary List Waypoints Detail
         * @param {number} trackId 
         * @param {number | null} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaypointDetailResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId, segmentId, limit, offset, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Waypoint
         * @param {number} waypointId 
         * @param {WaypointUpdate} waypointUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaypointArtrackWaypointsWaypointIdPut(waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWaypointArtrackWaypointsWaypointIdPut(waypointId, waypointUpdate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.updateWaypointArtrackWaypointsWaypointIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Chunk Part
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {number} index 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId, mediaSlot, index, file, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload media file for a waypoint
         * @summary Upload Media File
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {File} file 
         * @param {number} waypointId 
         * @param {string} mediaType 
         * @param {string | null} [xContentHash] 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [metadataJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId, mediaSlot, file, waypointId, mediaType, xContentHash, xAPIKEY, metadataJson, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtrackWaypointsApi.uploadMediaFileArtrackUploadSessionIdMediaSlotPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtrackWaypointsApi - factory interface
 */
export const ArtrackWaypointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtrackWaypointsApiFp(configuration)
    return {
        /**
         * 
         * @summary Complete Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkCompleteRequest} chunkCompleteRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId, mediaSlot, chunkCompleteRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete upload session and finalize waypoint
         * @summary Complete Upload Session
         * @param {string} sessionId 
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId: string, waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId, waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Create waypoints for a track
         * @summary Create Waypoints
         * @param {number} trackId 
         * @param {WaypointBatch} waypointBatch 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaypointsArtrackTrackIdWaypointsPost(trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointBatchResponse> {
            return localVarFp.createWaypointsArtrackTrackIdWaypointsPost(trackId, waypointBatch, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Waypoint
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Waypoint Detail
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointDetailResponse> {
            return localVarFp.getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get waypoint processing status
         * @summary Get Waypoint Status
         * @param {number} waypointId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaypointStatusResponse> {
            return localVarFp.getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Init Chunked Upload
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {ChunkInitRequest} chunkInitRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<ChunkInitResponse> {
            return localVarFp.initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId, mediaSlot, chunkInitRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * List waypoints
         * @summary List Waypoints
         * @param {number} [trackId] 
         * @param {number} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsArtrackWaypointsGet(trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WaypointListItem>> {
            return localVarFp.listWaypointsArtrackWaypointsGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Return full waypoint details for a given track (coords, times, media summary).
         * @summary List Waypoints Detail
         * @param {number} trackId 
         * @param {number | null} [segmentId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WaypointDetailResponse>> {
            return localVarFp.listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Waypoint
         * @param {number} waypointId 
         * @param {WaypointUpdate} waypointUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaypointArtrackWaypointsWaypointIdPut(waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateWaypointArtrackWaypointsWaypointIdPut(waypointId, waypointUpdate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Chunk Part
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {number} index 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId, mediaSlot, index, file, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload media file for a waypoint
         * @summary Upload Media File
         * @param {string} sessionId 
         * @param {number} mediaSlot 
         * @param {File} file 
         * @param {number} waypointId 
         * @param {string} mediaType 
         * @param {string | null} [xContentHash] 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [metadataJson] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId, mediaSlot, file, waypointId, mediaType, xContentHash, xAPIKEY, metadataJson, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtrackWaypointsApi - object-oriented interface
 */
export class ArtrackWaypointsApi extends BaseAPI {
    /**
     * 
     * @summary Complete Chunked Upload
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {ChunkCompleteRequest} chunkCompleteRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId: string, mediaSlot: number, chunkCompleteRequest: ChunkCompleteRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).completeChunkedUploadArtrackUploadSessionIdMediaSlotCompleteChunkedPost(sessionId, mediaSlot, chunkCompleteRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete upload session and finalize waypoint
     * @summary Complete Upload Session
     * @param {string} sessionId 
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId: string, waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).completeUploadSessionArtrackUploadSessionIdCompletePost(sessionId, waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create waypoints for a track
     * @summary Create Waypoints
     * @param {number} trackId 
     * @param {WaypointBatch} waypointBatch 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWaypointsArtrackTrackIdWaypointsPost(trackId: number, waypointBatch: WaypointBatch, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).createWaypointsArtrackTrackIdWaypointsPost(trackId, waypointBatch, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Waypoint
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).deleteWaypointArtrackWaypointsWaypointIdDelete(waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Waypoint Detail
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).getWaypointDetailArtrackWaypointsWaypointIdGet(waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get waypoint processing status
     * @summary Get Waypoint Status
     * @param {number} waypointId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).getWaypointStatusArtrackWaypointsWaypointIdStatusGet(waypointId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Init Chunked Upload
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {ChunkInitRequest} chunkInitRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId: string, mediaSlot: number, chunkInitRequest: ChunkInitRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).initChunkedUploadArtrackUploadSessionIdMediaSlotInitPost(sessionId, mediaSlot, chunkInitRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List waypoints
     * @summary List Waypoints
     * @param {number} [trackId] 
     * @param {number} [segmentId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWaypointsArtrackWaypointsGet(trackId?: number, segmentId?: number, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).listWaypointsArtrackWaypointsGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return full waypoint details for a given track (coords, times, media summary).
     * @summary List Waypoints Detail
     * @param {number} trackId 
     * @param {number | null} [segmentId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId: number, segmentId?: number | null, limit?: number, offset?: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).listWaypointsDetailArtrackTracksTrackIdWaypointsDetailGet(trackId, segmentId, limit, offset, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Waypoint
     * @param {number} waypointId 
     * @param {WaypointUpdate} waypointUpdate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWaypointArtrackWaypointsWaypointIdPut(waypointId: number, waypointUpdate: WaypointUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).updateWaypointArtrackWaypointsWaypointIdPut(waypointId, waypointUpdate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Chunk Part
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {number} index 
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId: string, mediaSlot: number, index: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).uploadChunkPartArtrackUploadSessionIdMediaSlotPartsIndexPut(sessionId, mediaSlot, index, file, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload media file for a waypoint
     * @summary Upload Media File
     * @param {string} sessionId 
     * @param {number} mediaSlot 
     * @param {File} file 
     * @param {number} waypointId 
     * @param {string} mediaType 
     * @param {string | null} [xContentHash] 
     * @param {string} [xAPIKEY] 
     * @param {string | null} [metadataJson] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId: string, mediaSlot: number, file: File, waypointId: number, mediaType: string, xContentHash?: string | null, xAPIKEY?: string, metadataJson?: string | null, options?: RawAxiosRequestConfig) {
        return ArtrackWaypointsApiFp(this.configuration).uploadMediaFileArtrackUploadSessionIdMediaSlotPost(sessionId, mediaSlot, file, waypointId, mediaType, xContentHash, xAPIKEY, metadataJson, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Artrack Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artrackHealthArtrackHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artrack/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel Dialog Job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDialogJobAiDialogCancelPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelDialogJobAiDialogCancelPost', 'id', id)
            const localVarPath = `/ai/dialog/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Chatgpt Endpoint
         * @param {Prompt} prompt 
         * @param {string | null} [model] OpenAI model id or alias; default gpt-4o
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatgptEndpointAiChatgptPost: async (prompt: Prompt, model?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prompt' is not null or undefined
            assertParamExists('chatgptEndpointAiChatgptPost', 'prompt', prompt)
            const localVarPath = `/ai/chatgpt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prompt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Claude Endpoint
         * @param {Prompt} prompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claudeEndpointAiClaudePost: async (prompt: Prompt, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prompt' is not null or undefined
            assertParamExists('claudeEndpointAiClaudePost', 'prompt', prompt)
            const localVarPath = `/ai/claude`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prompt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear Temp Dialog Chunks
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearTempDialogChunksAiDialogClearTempPost: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clearTempDialogChunksAiDialogClearTempPost', 'id', id)
            const localVarPath = `/ai/dialog/clear_temp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Debug Audio
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugAudioStorageAdminDebugAudioGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('debugAudioStorageAdminDebugAudioGet', 'id', id)
            const localVarPath = `/storage/admin/debug_audio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gemini Endpoint
         * @param {string | null} [model] Gemini model id or alias; default gemini-1.5-flash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geminiEndpointAiGeminiPost: async (model?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai/gemini`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates an image from a text prompt using Google\'s Vertex AI Imagen and saves it to storage.
         * @summary Generate Image Endpoint
         * @param {ImageGenRequest} imageGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateImageEndpointAiGenimagePost: async (imageGenRequest: ImageGenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageGenRequest' is not null or undefined
            assertParamExists('generateImageEndpointAiGenimagePost', 'imageGenRequest', imageGenRequest)
            const localVarPath = `/ai/genimage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(imageGenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a music track from a text prompt using ElevenLabs Music API and saves it to storage.
         * @summary Generate Music Eleven Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMusicElevenEndpointAiGenmusicElevenPost: async (audioGenRequest: AudioGenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audioGenRequest' is not null or undefined
            assertParamExists('generateMusicElevenEndpointAiGenmusicElevenPost', 'audioGenRequest', audioGenRequest)
            const localVarPath = `/ai/genmusic_eleven`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(audioGenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a music track from a text prompt using Stable Audio via AIMLAPI and saves it to storage.
         * @summary Generate Music Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMusicEndpointAiGenmusicPost: async (audioGenRequest: AudioGenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audioGenRequest' is not null or undefined
            assertParamExists('generateMusicEndpointAiGenmusicPost', 'audioGenRequest', audioGenRequest)
            const localVarPath = `/ai/genmusic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(audioGenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a sound effect, analyzes its volume, and saves it to storage if it\'s not silent.
         * @summary Generate Sfx Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSfxEndpointAiGensfxPost: async (audioGenRequest: AudioGenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audioGenRequest' is not null or undefined
            assertParamExists('generateSfxEndpointAiGensfxPost', 'audioGenRequest', audioGenRequest)
            const localVarPath = `/ai/gensfx`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(audioGenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles both single voice TTS and complex audio drama generation.
         * @summary Generate Speech Endpoint
         * @param {SpeechRequest} speechRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSpeechEndpointAiGenerateSpeechPost: async (speechRequest: SpeechRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'speechRequest' is not null or undefined
            assertParamExists('generateSpeechEndpointAiGenerateSpeechPost', 'speechRequest', speechRequest)
            const localVarPath = `/ai/generate_speech`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(speechRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the result of a depth map generation job.
         * @summary Get Depth Generation Result
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepthGenerationResultAiGendepthResultJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getDepthGenerationResultAiGendepthResultJobIdGet', 'jobId', jobId)
            const localVarPath = `/ai_gendepth_result/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Dialog Status
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDialogStatusAiDialogStatusGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDialogStatusAiDialogStatusGet', 'id', id)
            const localVarPath = `/ai/dialog/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Temp Dialog Chunk
         * @param {string} id 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempDialogChunkAiDialogTempchunkGet: async (id: string, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTempDialogChunkAiDialogTempchunkGet', 'id', id)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getTempDialogChunkAiDialogTempchunkGet', 'index', index)
            const localVarPath = `/ai/dialog/tempchunk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Serves a web-optimized preview for an image by storage object id. Falls back to the original file if no webview exists.
         * @summary Image Preview
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagePreviewImgpreviewGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('imagePreviewImgpreviewGet', 'id', id)
            const localVarPath = `/imgpreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Legacy callback endpoint - no longer needed but keeps Mac API happy
         * @summary Legacy Transcode Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTranscodeCallbackTranscodeCallbackPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transcode/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Legacy progress endpoint - no longer needed but keeps Mac API happy
         * @summary Legacy Transcode Progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTranscodeProgressTranscodeProgressPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transcode/progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Webhook for the external service to call when the job is complete.
         * @summary Receive Depth Generation Webhook
         * @param {string} jobId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost: async (jobId: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost', 'jobId', jobId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost', 'requestBody', requestBody)
            const localVarPath = `/ai_gendepth_webhook/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a new depth map generation job by calling the external Artificial Studio API.
         * @summary Start Depth Generation Job
         * @param {DepthJobRequest} depthJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDepthGenerationJobAiGendepthPost: async (depthJobRequest: DepthJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'depthJobRequest' is not null or undefined
            assertParamExists('startDepthGenerationJobAiGendepthPost', 'depthJobRequest', depthJobRequest)
            const localVarPath = `/ai_gendepth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(depthJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start Dialog Job
         * @param {SpeechRequest} speechRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDialogJobAiDialogStartPost: async (speechRequest: SpeechRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'speechRequest' is not null or undefined
            assertParamExists('startDialogJobAiDialogStartPost', 'speechRequest', speechRequest)
            const localVarPath = `/ai/dialog/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(speechRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upscales an input image using Stability AI\'s v2beta fast upscale endpoint and saves it. Accepts either a base64 data URL (req.image_b64) or a direct image URL (req.image_url).
         * @summary Upscale Image Endpoint
         * @param {UpscaleRequest} upscaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upscaleImageEndpointAiUpscalePost: async (upscaleRequest: UpscaleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upscaleRequest' is not null or undefined
            assertParamExists('upscaleImageEndpointAiUpscalePost', 'upscaleRequest', upscaleRequest)
            const localVarPath = `/ai/upscale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-KEY", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upscaleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Artrack Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async artrackHealthArtrackHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.artrackHealthArtrackHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.artrackHealthArtrackHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel Dialog Job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDialogJobAiDialogCancelPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDialogJobAiDialogCancelPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.cancelDialogJobAiDialogCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Chatgpt Endpoint
         * @param {Prompt} prompt 
         * @param {string | null} [model] OpenAI model id or alias; default gpt-4o
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatgptEndpointAiChatgptPost(prompt: Prompt, model?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatgptEndpointAiChatgptPost(prompt, model, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.chatgptEndpointAiChatgptPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Claude Endpoint
         * @param {Prompt} prompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claudeEndpointAiClaudePost(prompt: Prompt, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claudeEndpointAiClaudePost(prompt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.claudeEndpointAiClaudePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Clear Temp Dialog Chunks
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearTempDialogChunksAiDialogClearTempPost(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearTempDialogChunksAiDialogClearTempPost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.clearTempDialogChunksAiDialogClearTempPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Debug Audio
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debugAudioStorageAdminDebugAudioGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debugAudioStorageAdminDebugAudioGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.debugAudioStorageAdminDebugAudioGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gemini Endpoint
         * @param {string | null} [model] Gemini model id or alias; default gemini-1.5-flash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geminiEndpointAiGeminiPost(model?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geminiEndpointAiGeminiPost(model, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.geminiEndpointAiGeminiPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates an image from a text prompt using Google\'s Vertex AI Imagen and saves it to storage.
         * @summary Generate Image Endpoint
         * @param {ImageGenRequest} imageGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateImageEndpointAiGenimagePost(imageGenRequest: ImageGenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateImageEndpointAiGenimagePost(imageGenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateImageEndpointAiGenimagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a music track from a text prompt using ElevenLabs Music API and saves it to storage.
         * @summary Generate Music Eleven Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateMusicElevenEndpointAiGenmusicElevenPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateMusicElevenEndpointAiGenmusicElevenPost(audioGenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateMusicElevenEndpointAiGenmusicElevenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a music track from a text prompt using Stable Audio via AIMLAPI and saves it to storage.
         * @summary Generate Music Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateMusicEndpointAiGenmusicPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateMusicEndpointAiGenmusicPost(audioGenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateMusicEndpointAiGenmusicPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a sound effect, analyzes its volume, and saves it to storage if it\'s not silent.
         * @summary Generate Sfx Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSfxEndpointAiGensfxPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSfxEndpointAiGensfxPost(audioGenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateSfxEndpointAiGensfxPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles both single voice TTS and complex audio drama generation.
         * @summary Generate Speech Endpoint
         * @param {SpeechRequest} speechRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSpeechEndpointAiGenerateSpeechPost(speechRequest: SpeechRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSpeechEndpointAiGenerateSpeechPost(speechRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateSpeechEndpointAiGenerateSpeechPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the result of a depth map generation job.
         * @summary Get Depth Generation Result
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepthGenerationResultAiGendepthResultJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepthGenerationResultAiGendepthResultJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDepthGenerationResultAiGendepthResultJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Dialog Status
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDialogStatusAiDialogStatusGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDialogStatusAiDialogStatusGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDialogStatusAiDialogStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Temp Dialog Chunk
         * @param {string} id 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTempDialogChunkAiDialogTempchunkGet(id: string, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTempDialogChunkAiDialogTempchunkGet(id, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTempDialogChunkAiDialogTempchunkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Serves a web-optimized preview for an image by storage object id. Falls back to the original file if no webview exists.
         * @summary Image Preview
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async imagePreviewImgpreviewGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.imagePreviewImgpreviewGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.imagePreviewImgpreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Legacy callback endpoint - no longer needed but keeps Mac API happy
         * @summary Legacy Transcode Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyTranscodeCallbackTranscodeCallbackPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyTranscodeCallbackTranscodeCallbackPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.legacyTranscodeCallbackTranscodeCallbackPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Legacy progress endpoint - no longer needed but keeps Mac API happy
         * @summary Legacy Transcode Progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyTranscodeProgressTranscodeProgressPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyTranscodeProgressTranscodeProgressPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.legacyTranscodeProgressTranscodeProgressPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Webhook for the external service to call when the job is complete.
         * @summary Receive Depth Generation Webhook
         * @param {string} jobId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost(jobId: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost(jobId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a new depth map generation job by calling the external Artificial Studio API.
         * @summary Start Depth Generation Job
         * @param {DepthJobRequest} depthJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startDepthGenerationJobAiGendepthPost(depthJobRequest: DepthJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startDepthGenerationJobAiGendepthPost(depthJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.startDepthGenerationJobAiGendepthPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start Dialog Job
         * @param {SpeechRequest} speechRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startDialogJobAiDialogStartPost(speechRequest: SpeechRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startDialogJobAiDialogStartPost(speechRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.startDialogJobAiDialogStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upscales an input image using Stability AI\'s v2beta fast upscale endpoint and saves it. Accepts either a base64 data URL (req.image_b64) or a direct image URL (req.image_url).
         * @summary Upscale Image Endpoint
         * @param {UpscaleRequest} upscaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upscaleImageEndpointAiUpscalePost(upscaleRequest: UpscaleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upscaleImageEndpointAiUpscalePost(upscaleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.upscaleImageEndpointAiUpscalePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Artrack Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artrackHealthArtrackHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.artrackHealthArtrackHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel Dialog Job
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDialogJobAiDialogCancelPost(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.cancelDialogJobAiDialogCancelPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Chatgpt Endpoint
         * @param {Prompt} prompt 
         * @param {string | null} [model] OpenAI model id or alias; default gpt-4o
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatgptEndpointAiChatgptPost(prompt: Prompt, model?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.chatgptEndpointAiChatgptPost(prompt, model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Claude Endpoint
         * @param {Prompt} prompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claudeEndpointAiClaudePost(prompt: Prompt, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.claudeEndpointAiClaudePost(prompt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clear Temp Dialog Chunks
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearTempDialogChunksAiDialogClearTempPost(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.clearTempDialogChunksAiDialogClearTempPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Debug Audio
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debugAudioStorageAdminDebugAudioGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.debugAudioStorageAdminDebugAudioGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gemini Endpoint
         * @param {string | null} [model] Gemini model id or alias; default gemini-1.5-flash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geminiEndpointAiGeminiPost(model?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.geminiEndpointAiGeminiPost(model, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates an image from a text prompt using Google\'s Vertex AI Imagen and saves it to storage.
         * @summary Generate Image Endpoint
         * @param {ImageGenRequest} imageGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateImageEndpointAiGenimagePost(imageGenRequest: ImageGenRequest, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.generateImageEndpointAiGenimagePost(imageGenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a music track from a text prompt using ElevenLabs Music API and saves it to storage.
         * @summary Generate Music Eleven Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMusicElevenEndpointAiGenmusicElevenPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.generateMusicElevenEndpointAiGenmusicElevenPost(audioGenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a music track from a text prompt using Stable Audio via AIMLAPI and saves it to storage.
         * @summary Generate Music Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateMusicEndpointAiGenmusicPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.generateMusicEndpointAiGenmusicPost(audioGenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a sound effect, analyzes its volume, and saves it to storage if it\'s not silent.
         * @summary Generate Sfx Endpoint
         * @param {AudioGenRequest} audioGenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSfxEndpointAiGensfxPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.generateSfxEndpointAiGensfxPost(audioGenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handles both single voice TTS and complex audio drama generation.
         * @summary Generate Speech Endpoint
         * @param {SpeechRequest} speechRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSpeechEndpointAiGenerateSpeechPost(speechRequest: SpeechRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.generateSpeechEndpointAiGenerateSpeechPost(speechRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the result of a depth map generation job.
         * @summary Get Depth Generation Result
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepthGenerationResultAiGendepthResultJobIdGet(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDepthGenerationResultAiGendepthResultJobIdGet(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Dialog Status
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDialogStatusAiDialogStatusGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDialogStatusAiDialogStatusGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Temp Dialog Chunk
         * @param {string} id 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTempDialogChunkAiDialogTempchunkGet(id: string, index: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTempDialogChunkAiDialogTempchunkGet(id, index, options).then((request) => request(axios, basePath));
        },
        /**
         * Serves a web-optimized preview for an image by storage object id. Falls back to the original file if no webview exists.
         * @summary Image Preview
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagePreviewImgpreviewGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.imagePreviewImgpreviewGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Legacy callback endpoint - no longer needed but keeps Mac API happy
         * @summary Legacy Transcode Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTranscodeCallbackTranscodeCallbackPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.legacyTranscodeCallbackTranscodeCallbackPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Legacy progress endpoint - no longer needed but keeps Mac API happy
         * @summary Legacy Transcode Progress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyTranscodeProgressTranscodeProgressPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.legacyTranscodeProgressTranscodeProgressPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Webhook for the external service to call when the job is complete.
         * @summary Receive Depth Generation Webhook
         * @param {string} jobId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost(jobId: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost(jobId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a new depth map generation job by calling the external Artificial Studio API.
         * @summary Start Depth Generation Job
         * @param {DepthJobRequest} depthJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDepthGenerationJobAiGendepthPost(depthJobRequest: DepthJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.startDepthGenerationJobAiGendepthPost(depthJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start Dialog Job
         * @param {SpeechRequest} speechRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDialogJobAiDialogStartPost(speechRequest: SpeechRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.startDialogJobAiDialogStartPost(speechRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upscales an input image using Stability AI\'s v2beta fast upscale endpoint and saves it. Accepts either a base64 data URL (req.image_b64) or a direct image URL (req.image_url).
         * @summary Upscale Image Endpoint
         * @param {UpscaleRequest} upscaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upscaleImageEndpointAiUpscalePost(upscaleRequest: UpscaleRequest, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.upscaleImageEndpointAiUpscalePost(upscaleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Artrack Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public artrackHealthArtrackHealthGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).artrackHealthArtrackHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel Dialog Job
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelDialogJobAiDialogCancelPost(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelDialogJobAiDialogCancelPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Chatgpt Endpoint
     * @param {Prompt} prompt 
     * @param {string | null} [model] OpenAI model id or alias; default gpt-4o
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public chatgptEndpointAiChatgptPost(prompt: Prompt, model?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).chatgptEndpointAiChatgptPost(prompt, model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Claude Endpoint
     * @param {Prompt} prompt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public claudeEndpointAiClaudePost(prompt: Prompt, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).claudeEndpointAiClaudePost(prompt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clear Temp Dialog Chunks
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public clearTempDialogChunksAiDialogClearTempPost(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).clearTempDialogChunksAiDialogClearTempPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Debug Audio
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public debugAudioStorageAdminDebugAudioGet(id: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).debugAudioStorageAdminDebugAudioGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gemini Endpoint
     * @param {string | null} [model] Gemini model id or alias; default gemini-1.5-flash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public geminiEndpointAiGeminiPost(model?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).geminiEndpointAiGeminiPost(model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates an image from a text prompt using Google\'s Vertex AI Imagen and saves it to storage.
     * @summary Generate Image Endpoint
     * @param {ImageGenRequest} imageGenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateImageEndpointAiGenimagePost(imageGenRequest: ImageGenRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateImageEndpointAiGenimagePost(imageGenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a music track from a text prompt using ElevenLabs Music API and saves it to storage.
     * @summary Generate Music Eleven Endpoint
     * @param {AudioGenRequest} audioGenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateMusicElevenEndpointAiGenmusicElevenPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateMusicElevenEndpointAiGenmusicElevenPost(audioGenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a music track from a text prompt using Stable Audio via AIMLAPI and saves it to storage.
     * @summary Generate Music Endpoint
     * @param {AudioGenRequest} audioGenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateMusicEndpointAiGenmusicPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateMusicEndpointAiGenmusicPost(audioGenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a sound effect, analyzes its volume, and saves it to storage if it\'s not silent.
     * @summary Generate Sfx Endpoint
     * @param {AudioGenRequest} audioGenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateSfxEndpointAiGensfxPost(audioGenRequest: AudioGenRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateSfxEndpointAiGensfxPost(audioGenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handles both single voice TTS and complex audio drama generation.
     * @summary Generate Speech Endpoint
     * @param {SpeechRequest} speechRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateSpeechEndpointAiGenerateSpeechPost(speechRequest: SpeechRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateSpeechEndpointAiGenerateSpeechPost(speechRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the result of a depth map generation job.
     * @summary Get Depth Generation Result
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDepthGenerationResultAiGendepthResultJobIdGet(jobId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepthGenerationResultAiGendepthResultJobIdGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Dialog Status
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDialogStatusAiDialogStatusGet(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDialogStatusAiDialogStatusGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Temp Dialog Chunk
     * @param {string} id 
     * @param {number} index 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTempDialogChunkAiDialogTempchunkGet(id: string, index: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTempDialogChunkAiDialogTempchunkGet(id, index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Serves a web-optimized preview for an image by storage object id. Falls back to the original file if no webview exists.
     * @summary Image Preview
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public imagePreviewImgpreviewGet(id: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).imagePreviewImgpreviewGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Legacy callback endpoint - no longer needed but keeps Mac API happy
     * @summary Legacy Transcode Callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public legacyTranscodeCallbackTranscodeCallbackPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).legacyTranscodeCallbackTranscodeCallbackPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Legacy progress endpoint - no longer needed but keeps Mac API happy
     * @summary Legacy Transcode Progress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public legacyTranscodeProgressTranscodeProgressPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).legacyTranscodeProgressTranscodeProgressPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Webhook for the external service to call when the job is complete.
     * @summary Receive Depth Generation Webhook
     * @param {string} jobId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost(jobId: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).receiveDepthGenerationWebhookAiGendepthWebhookJobIdPost(jobId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a new depth map generation job by calling the external Artificial Studio API.
     * @summary Start Depth Generation Job
     * @param {DepthJobRequest} depthJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startDepthGenerationJobAiGendepthPost(depthJobRequest: DepthJobRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).startDepthGenerationJobAiGendepthPost(depthJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start Dialog Job
     * @param {SpeechRequest} speechRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startDialogJobAiDialogStartPost(speechRequest: SpeechRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).startDialogJobAiDialogStartPost(speechRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upscales an input image using Stability AI\'s v2beta fast upscale endpoint and saves it. Accepts either a base64 data URL (req.image_b64) or a direct image URL (req.image_url).
     * @summary Upscale Image Endpoint
     * @param {UpscaleRequest} upscaleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upscaleImageEndpointAiUpscalePost(upscaleRequest: UpscaleRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).upscaleImageEndpointAiUpscalePost(upscaleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogsApi - axios parameter creator
 */
export const LogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Log
         * @param {LogCreate} logCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogLogsPost: async (logCreate: LogCreate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logCreate' is not null or undefined
            assertParamExists('createLogLogsPost', 'logCreate', logCreate)
            const localVarPath = `/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generic system alert endpoint for all services  Examples: - Tunnel: service=\"tunnel\", component=\"ssh\", status=\"down\" - Transcoding: service=\"transcoding\", component=\"mac-api\", status=\"critical\" - Storage: service=\"storage\", component=\"database\", status=\"warning\"  - API: service=\"api\", component=\"auth\", status=\"healthy\"
         * @summary Create System Alert
         * @param {SystemAlert} systemAlert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSystemAlertAlertsPost: async (systemAlert: SystemAlert, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemAlert' is not null or undefined
            assertParamExists('createSystemAlertAlertsPost', 'systemAlert', systemAlert)
            const localVarPath = `/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemAlert, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all current service statuses and recent alerts
         * @summary Get All Service Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServiceStatusesAlertsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current status and recent alerts for a service/component
         * @summary Get Service Status
         * @param {string} service 
         * @param {string | null} [component] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatusAlertsServicesServiceGet: async (service: string, component?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'service' is not null or undefined
            assertParamExists('getServiceStatusAlertsServicesServiceGet', 'service', service)
            const localVarPath = `/alerts/services/{service}`
                .replace(`{${"service"}}`, encodeURIComponent(String(service)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (component !== undefined) {
                localVarQueryParameter['component'] = component;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent system monitor logs without authentication (public endpoint)
         * @summary Get System Alerts Logs
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemAlertsLogsAlertsLogsGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/alerts/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Logs
         * @param {number} [limit] 
         * @param {string | null} [level] 
         * @param {string | null} [appName] 
         * @param {boolean} [userOnly] If true, only logs created by the caller
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogsLogsGet: async (limit?: number, level?: string | null, appName?: string | null, userOnly?: boolean, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (appName !== undefined) {
                localVarQueryParameter['app_name'] = appName;
            }

            if (userOnly !== undefined) {
                localVarQueryParameter['user_only'] = userOnly;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple HTML dashboard showing all service statuses
         * @summary System Dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemDashboardAlertsDashboardGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/alerts/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogsApi - functional programming interface
 */
export const LogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Log
         * @param {LogCreate} logCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLogLogsPost(logCreate: LogCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLogLogsPost(logCreate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.createLogLogsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generic system alert endpoint for all services  Examples: - Tunnel: service=\"tunnel\", component=\"ssh\", status=\"down\" - Transcoding: service=\"transcoding\", component=\"mac-api\", status=\"critical\" - Storage: service=\"storage\", component=\"database\", status=\"warning\"  - API: service=\"api\", component=\"auth\", status=\"healthy\"
         * @summary Create System Alert
         * @param {SystemAlert} systemAlert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSystemAlertAlertsPost(systemAlert: SystemAlert, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSystemAlertAlertsPost(systemAlert, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.createSystemAlertAlertsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all current service statuses and recent alerts
         * @summary Get All Service Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllServiceStatusesAlertsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllServiceStatusesAlertsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.getAllServiceStatusesAlertsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current status and recent alerts for a service/component
         * @summary Get Service Status
         * @param {string} service 
         * @param {string | null} [component] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceStatusAlertsServicesServiceGet(service: string, component?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceStatusAlertsServicesServiceGet(service, component, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.getServiceStatusAlertsServicesServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent system monitor logs without authentication (public endpoint)
         * @summary Get System Alerts Logs
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSystemAlertsLogsAlertsLogsGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSystemAlertsLogsAlertsLogsGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.getSystemAlertsLogsAlertsLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Logs
         * @param {number} [limit] 
         * @param {string | null} [level] 
         * @param {string | null} [appName] 
         * @param {boolean} [userOnly] If true, only logs created by the caller
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLogsLogsGet(limit?: number, level?: string | null, appName?: string | null, userOnly?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLogsLogsGet(limit, level, appName, userOnly, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.listLogsLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple HTML dashboard showing all service statuses
         * @summary System Dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemDashboardAlertsDashboardGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemDashboardAlertsDashboardGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.systemDashboardAlertsDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogsApi - factory interface
 */
export const LogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Log
         * @param {LogCreate} logCreate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogLogsPost(logCreate: LogCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<LogResponse> {
            return localVarFp.createLogLogsPost(logCreate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Generic system alert endpoint for all services  Examples: - Tunnel: service=\"tunnel\", component=\"ssh\", status=\"down\" - Transcoding: service=\"transcoding\", component=\"mac-api\", status=\"critical\" - Storage: service=\"storage\", component=\"database\", status=\"warning\"  - API: service=\"api\", component=\"auth\", status=\"healthy\"
         * @summary Create System Alert
         * @param {SystemAlert} systemAlert 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSystemAlertAlertsPost(systemAlert: SystemAlert, options?: RawAxiosRequestConfig): AxiosPromise<LogResponse> {
            return localVarFp.createSystemAlertAlertsPost(systemAlert, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all current service statuses and recent alerts
         * @summary Get All Service Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServiceStatusesAlertsGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAllServiceStatusesAlertsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get current status and recent alerts for a service/component
         * @summary Get Service Status
         * @param {string} service 
         * @param {string | null} [component] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceStatusAlertsServicesServiceGet(service: string, component?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ServiceStatusResponse> {
            return localVarFp.getServiceStatusAlertsServicesServiceGet(service, component, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent system monitor logs without authentication (public endpoint)
         * @summary Get System Alerts Logs
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemAlertsLogsAlertsLogsGet(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getSystemAlertsLogsAlertsLogsGet(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Logs
         * @param {number} [limit] 
         * @param {string | null} [level] 
         * @param {string | null} [appName] 
         * @param {boolean} [userOnly] If true, only logs created by the caller
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogsLogsGet(limit?: number, level?: string | null, appName?: string | null, userOnly?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogResponse>> {
            return localVarFp.listLogsLogsGet(limit, level, appName, userOnly, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Simple HTML dashboard showing all service statuses
         * @summary System Dashboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemDashboardAlertsDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.systemDashboardAlertsDashboardGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogsApi - object-oriented interface
 */
export class LogsApi extends BaseAPI {
    /**
     * 
     * @summary Create Log
     * @param {LogCreate} logCreate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLogLogsPost(logCreate: LogCreate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).createLogLogsPost(logCreate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generic system alert endpoint for all services  Examples: - Tunnel: service=\"tunnel\", component=\"ssh\", status=\"down\" - Transcoding: service=\"transcoding\", component=\"mac-api\", status=\"critical\" - Storage: service=\"storage\", component=\"database\", status=\"warning\"  - API: service=\"api\", component=\"auth\", status=\"healthy\"
     * @summary Create System Alert
     * @param {SystemAlert} systemAlert 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSystemAlertAlertsPost(systemAlert: SystemAlert, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).createSystemAlertAlertsPost(systemAlert, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all current service statuses and recent alerts
     * @summary Get All Service Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllServiceStatusesAlertsGet(options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).getAllServiceStatusesAlertsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current status and recent alerts for a service/component
     * @summary Get Service Status
     * @param {string} service 
     * @param {string | null} [component] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getServiceStatusAlertsServicesServiceGet(service: string, component?: string | null, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).getServiceStatusAlertsServicesServiceGet(service, component, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent system monitor logs without authentication (public endpoint)
     * @summary Get System Alerts Logs
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSystemAlertsLogsAlertsLogsGet(limit?: number, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).getSystemAlertsLogsAlertsLogsGet(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Logs
     * @param {number} [limit] 
     * @param {string | null} [level] 
     * @param {string | null} [appName] 
     * @param {boolean} [userOnly] If true, only logs created by the caller
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listLogsLogsGet(limit?: number, level?: string | null, appName?: string | null, userOnly?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).listLogsLogsGet(limit, level, appName, userOnly, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple HTML dashboard showing all service statuses
     * @summary System Dashboard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public systemDashboardAlertsDashboardGet(options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).systemDashboardAlertsDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StorageApi - axios parameter creator
 */
export const StorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Analyze Existing Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeExistingObjectStorageObjectsObjectIdAnalyzePost: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('analyzeExistingObjectStorageObjectsObjectIdAnalyzePost', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/analyze`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteObjectStorageObjectIdDelete: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('deleteObjectStorageObjectIdDelete', 'objectId', objectId)
            const localVarPath = `/storage/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download File
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStorageFilesObjectIdGet: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('downloadFileStorageFilesObjectIdGet', 'objectId', objectId)
            const localVarPath = `/storage/files/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch And Store Remote
         * @param {RemoteFetchRequest} remoteFetchRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAndStoreRemoteStorageFetchPost: async (remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'remoteFetchRequest' is not null or undefined
            assertParamExists('fetchAndStoreRemoteStorageFetchPost', 'remoteFetchRequest', remoteFetchRequest)
            const localVarPath = `/storage/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(remoteFetchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Object Metadata
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectMetadataStorageObjectsObjectIdGet: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('getObjectMetadataStorageObjectsObjectIdGet', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Like Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeObjectStorageObjectsObjectIdLikePost: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('likeObjectStorageObjectsObjectIdLikePost', 'objectId', objectId)
            const localVarPath = `/storage/objects/{object_id}/like`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Objects
         * @param {boolean} [mine] 
         * @param {string | null} [context] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObjectsStorageListGet: async (mine?: boolean, context?: string | null, collectionId?: string | null, linkId?: string | null, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mine !== undefined) {
                localVarQueryParameter['mine'] = mine;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (collectionId !== undefined) {
                localVarQueryParameter['collection_id'] = collectionId;
            }

            if (linkId !== undefined) {
                localVarQueryParameter['link_id'] = linkId;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace File
         * @param {number} objectId 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceFileStorageFilesObjectIdPut: async (objectId: number, file: File, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('replaceFileStorageFilesObjectIdPut', 'objectId', objectId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('replaceFileStorageFilesObjectIdPut', 'file', file)
            const localVarPath = `/storage/files/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Object Metadata
         * @param {number} objectId 
         * @param {StorageObjectUpdate} storageObjectUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObjectMetadataStorageObjectsObjectIdPatch: async (objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('updateObjectMetadataStorageObjectsObjectIdPatch', 'objectId', objectId)
            // verify required parameter 'storageObjectUpdate' is not null or undefined
            assertParamExists('updateObjectMetadataStorageObjectsObjectIdPatch', 'storageObjectUpdate', storageObjectUpdate)
            const localVarPath = `/storage/objects/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storageObjectUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload File
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [context] 
         * @param {boolean} [isPublic] 
         * @param {string | null} [ownerEmail] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {boolean} [analyze] 
         * @param {string | null} [referenceId] 
         * @param {boolean} [hlsResult] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileStorageUploadPost: async (file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFileStorageUploadPost', 'file', file)
            const localVarPath = `/storage/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (context !== undefined) { 
                localVarFormParams.append('context', context as any);
            }
    
            if (isPublic !== undefined) { 
                localVarFormParams.append('is_public', String(isPublic) as any);
            }
    
            if (ownerEmail !== undefined) { 
                localVarFormParams.append('owner_email', ownerEmail as any);
            }
    
            if (collectionId !== undefined) { 
                localVarFormParams.append('collection_id', collectionId as any);
            }
    
            if (linkId !== undefined) { 
                localVarFormParams.append('link_id', linkId as any);
            }
    
            if (analyze !== undefined) { 
                localVarFormParams.append('analyze', String(analyze) as any);
            }
    
            if (referenceId !== undefined) { 
                localVarFormParams.append('reference_id', referenceId as any);
            }
    
            if (hlsResult !== undefined) { 
                localVarFormParams.append('hls_result', String(hlsResult) as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageApi - functional programming interface
 */
export const StorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Analyze Existing Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.analyzeExistingObjectStorageObjectsObjectIdAnalyzePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteObjectStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteObjectStorageObjectIdDelete(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.deleteObjectStorageObjectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download File
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileStorageFilesObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileStorageFilesObjectIdGet(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.downloadFileStorageFilesObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch And Store Remote
         * @param {RemoteFetchRequest} remoteFetchRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.fetchAndStoreRemoteStorageFetchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Object Metadata
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObjectMetadataStorageObjectsObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObjectMetadataStorageObjectsObjectIdGet(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.getObjectMetadataStorageObjectsObjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Like Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async likeObjectStorageObjectsObjectIdLikePost(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.likeObjectStorageObjectsObjectIdLikePost(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.likeObjectStorageObjectsObjectIdLikePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Objects
         * @param {boolean} [mine] 
         * @param {string | null} [context] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listObjectsStorageListGet(mine?: boolean, context?: string | null, collectionId?: string | null, linkId?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listObjectsStorageListGet(mine, context, collectionId, linkId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.listObjectsStorageListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace File
         * @param {number} objectId 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceFileStorageFilesObjectIdPut(objectId: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceFileStorageFilesObjectIdPut(objectId, file, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.replaceFileStorageFilesObjectIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Object Metadata
         * @param {number} objectId 
         * @param {StorageObjectUpdate} storageObjectUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateObjectMetadataStorageObjectsObjectIdPatch(objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateObjectMetadataStorageObjectsObjectIdPatch(objectId, storageObjectUpdate, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.updateObjectMetadataStorageObjectsObjectIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload File
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [context] 
         * @param {boolean} [isPublic] 
         * @param {string | null} [ownerEmail] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {boolean} [analyze] 
         * @param {string | null} [referenceId] 
         * @param {boolean} [hlsResult] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileStorageUploadPost(file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageObjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFileStorageUploadPost(file, xAPIKEY, context, isPublic, ownerEmail, collectionId, linkId, analyze, referenceId, hlsResult, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageApi.uploadFileStorageUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorageApi - factory interface
 */
export const StorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageApiFp(configuration)
    return {
        /**
         * 
         * @summary Analyze Existing Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Object
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteObjectStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteObjectStorageObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download File
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStorageFilesObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadFileStorageFilesObjectIdGet(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch And Store Remote
         * @param {RemoteFetchRequest} remoteFetchRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Object Metadata
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectMetadataStorageObjectsObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.getObjectMetadataStorageObjectsObjectIdGet(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Like Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeObjectStorageObjectsObjectIdLikePost(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.likeObjectStorageObjectsObjectIdLikePost(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Objects
         * @param {boolean} [mine] 
         * @param {string | null} [context] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listObjectsStorageListGet(mine?: boolean, context?: string | null, collectionId?: string | null, linkId?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageListResponse> {
            return localVarFp.listObjectsStorageListGet(mine, context, collectionId, linkId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace File
         * @param {number} objectId 
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceFileStorageFilesObjectIdPut(objectId: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.replaceFileStorageFilesObjectIdPut(objectId, file, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Object Metadata
         * @param {number} objectId 
         * @param {StorageObjectUpdate} storageObjectUpdate 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateObjectMetadataStorageObjectsObjectIdPatch(objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.updateObjectMetadataStorageObjectsObjectIdPatch(objectId, storageObjectUpdate, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload File
         * @param {File} file 
         * @param {string} [xAPIKEY] 
         * @param {string | null} [context] 
         * @param {boolean} [isPublic] 
         * @param {string | null} [ownerEmail] 
         * @param {string | null} [collectionId] 
         * @param {string | null} [linkId] 
         * @param {boolean} [analyze] 
         * @param {string | null} [referenceId] 
         * @param {boolean} [hlsResult] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileStorageUploadPost(file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<StorageObjectResponse> {
            return localVarFp.uploadFileStorageUploadPost(file, xAPIKEY, context, isPublic, ownerEmail, collectionId, linkId, analyze, referenceId, hlsResult, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorageApi - object-oriented interface
 */
export class StorageApi extends BaseAPI {
    /**
     * 
     * @summary Analyze Existing Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).analyzeExistingObjectStorageObjectsObjectIdAnalyzePost(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Object
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteObjectStorageObjectIdDelete(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).deleteObjectStorageObjectIdDelete(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download File
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadFileStorageFilesObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).downloadFileStorageFilesObjectIdGet(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch And Store Remote
     * @param {RemoteFetchRequest} remoteFetchRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest: RemoteFetchRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).fetchAndStoreRemoteStorageFetchPost(remoteFetchRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Object Metadata
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getObjectMetadataStorageObjectsObjectIdGet(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).getObjectMetadataStorageObjectsObjectIdGet(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Like Object
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public likeObjectStorageObjectsObjectIdLikePost(objectId: number, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).likeObjectStorageObjectsObjectIdLikePost(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Objects
     * @param {boolean} [mine] 
     * @param {string | null} [context] 
     * @param {string | null} [collectionId] 
     * @param {string | null} [linkId] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listObjectsStorageListGet(mine?: boolean, context?: string | null, collectionId?: string | null, linkId?: string | null, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).listObjectsStorageListGet(mine, context, collectionId, linkId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace File
     * @param {number} objectId 
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replaceFileStorageFilesObjectIdPut(objectId: number, file: File, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).replaceFileStorageFilesObjectIdPut(objectId, file, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Object Metadata
     * @param {number} objectId 
     * @param {StorageObjectUpdate} storageObjectUpdate 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateObjectMetadataStorageObjectsObjectIdPatch(objectId: number, storageObjectUpdate: StorageObjectUpdate, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).updateObjectMetadataStorageObjectsObjectIdPatch(objectId, storageObjectUpdate, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload File
     * @param {File} file 
     * @param {string} [xAPIKEY] 
     * @param {string | null} [context] 
     * @param {boolean} [isPublic] 
     * @param {string | null} [ownerEmail] 
     * @param {string | null} [collectionId] 
     * @param {string | null} [linkId] 
     * @param {boolean} [analyze] 
     * @param {string | null} [referenceId] 
     * @param {boolean} [hlsResult] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadFileStorageUploadPost(file: File, xAPIKEY?: string, context?: string | null, isPublic?: boolean, ownerEmail?: string | null, collectionId?: string | null, linkId?: string | null, analyze?: boolean, referenceId?: string | null, hlsResult?: boolean, options?: RawAxiosRequestConfig) {
        return StorageApiFp(this.configuration).uploadFileStorageUploadPost(file, xAPIKEY, context, isPublic, ownerEmail, collectionId, linkId, analyze, referenceId, hlsResult, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StorageAdminApi - axios parameter creator
 */
export const StorageAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes all storage objects older than a specified number of days.
         * @summary Admin Cleanup By Age
         * @param {CleanupByAgeRequest} cleanupByAgeRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupByAgeStorageAdminCleanupByAgePost: async (cleanupByAgeRequest: CleanupByAgeRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cleanupByAgeRequest' is not null or undefined
            assertParamExists('adminCleanupByAgeStorageAdminCleanupByAgePost', 'cleanupByAgeRequest', cleanupByAgeRequest)
            const localVarPath = `/storage/admin/cleanup/by-age`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cleanupByAgeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes all storage objects within a specific collection.
         * @summary Admin Cleanup By Collection
         * @param {CleanupByCollectionRequest} cleanupByCollectionRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupByCollectionStorageAdminCleanupByCollectionPost: async (cleanupByCollectionRequest: CleanupByCollectionRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cleanupByCollectionRequest' is not null or undefined
            assertParamExists('adminCleanupByCollectionStorageAdminCleanupByCollectionPost', 'cleanupByCollectionRequest', cleanupByCollectionRequest)
            const localVarPath = `/storage/admin/cleanup/by-collection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cleanupByCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Purges all storage objects owned by a specific user by their email.
         * @summary Admin Cleanup By User
         * @param {CleanupByUserRequest} cleanupByUserRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupByUserStorageAdminCleanupByUserPost: async (cleanupByUserRequest: CleanupByUserRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cleanupByUserRequest' is not null or undefined
            assertParamExists('adminCleanupByUserStorageAdminCleanupByUserPost', 'cleanupByUserRequest', cleanupByUserRequest)
            const localVarPath = `/storage/admin/cleanup/by-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cleanupByUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find storage object by mac_job_id in metadata_json
         * @summary Admin Find Storage By Mac Job
         * @param {string} jobId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet: async (jobId: string, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet', 'jobId', jobId)
            const localVarPath = `/storage/admin/find-by-mac-job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manually trigger processing for a storage object (admin-only)
         * @summary Admin Trigger Processing
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost: async (objectId: number, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost', 'objectId', objectId)
            const localVarPath = `/storage/admin/trigger-processing/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get collections for a specific user or public collections
         * @summary Get Collections For User
         * @param {string | null} [userEmail] 
         * @param {boolean} [publicOnly] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionsForUserStorageAdminCollectionsGet: async (userEmail?: string | null, publicOnly?: boolean, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/admin/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userEmail !== undefined) {
                localVarQueryParameter['user_email'] = userEmail;
            }

            if (publicOnly !== undefined) {
                localVarQueryParameter['public_only'] = publicOnly;
            }


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all users who have collections in storage
         * @summary Get Users With Collections
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersWithCollectionsStorageAdminUsersWithCollectionsGet: async (xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/admin/users-with-collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin-only: Transfer ownership of all storage objects that share the given link_id to the user identified by owner_email. Creates the user if necessary.
         * @summary Transfer Owner By Link
         * @param {TransferOwnerByLinkRequest} transferOwnerByLinkRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnerByLinkStorageAdminTransferOwnerByLinkPost: async (transferOwnerByLinkRequest: TransferOwnerByLinkRequest, xAPIKEY?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferOwnerByLinkRequest' is not null or undefined
            assertParamExists('transferOwnerByLinkStorageAdminTransferOwnerByLinkPost', 'transferOwnerByLinkRequest', transferOwnerByLinkRequest)
            const localVarPath = `/storage/admin/transfer_owner_by_link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAPIKEY != null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferOwnerByLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageAdminApi - functional programming interface
 */
export const StorageAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes all storage objects older than a specified number of days.
         * @summary Admin Cleanup By Age
         * @param {CleanupByAgeRequest} cleanupByAgeRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCleanupByAgeStorageAdminCleanupByAgePost(cleanupByAgeRequest: CleanupByAgeRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CleanupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCleanupByAgeStorageAdminCleanupByAgePost(cleanupByAgeRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.adminCleanupByAgeStorageAdminCleanupByAgePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes all storage objects within a specific collection.
         * @summary Admin Cleanup By Collection
         * @param {CleanupByCollectionRequest} cleanupByCollectionRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCleanupByCollectionStorageAdminCleanupByCollectionPost(cleanupByCollectionRequest: CleanupByCollectionRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CleanupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCleanupByCollectionStorageAdminCleanupByCollectionPost(cleanupByCollectionRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.adminCleanupByCollectionStorageAdminCleanupByCollectionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Purges all storage objects owned by a specific user by their email.
         * @summary Admin Cleanup By User
         * @param {CleanupByUserRequest} cleanupByUserRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCleanupByUserStorageAdminCleanupByUserPost(cleanupByUserRequest: CleanupByUserRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CleanupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCleanupByUserStorageAdminCleanupByUserPost(cleanupByUserRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.adminCleanupByUserStorageAdminCleanupByUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find storage object by mac_job_id in metadata_json
         * @summary Admin Find Storage By Mac Job
         * @param {string} jobId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet(jobId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet(jobId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Manually trigger processing for a storage object (admin-only)
         * @summary Admin Trigger Processing
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost(objectId, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get collections for a specific user or public collections
         * @summary Get Collections For User
         * @param {string | null} [userEmail] 
         * @param {boolean} [publicOnly] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionsForUserStorageAdminCollectionsGet(userEmail?: string | null, publicOnly?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CollectionInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionsForUserStorageAdminCollectionsGet(userEmail, publicOnly, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.getCollectionsForUserStorageAdminCollectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all users who have collections in storage
         * @summary Get Users With Collections
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersWithCollectionsStorageAdminUsersWithCollectionsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserWithCollections>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersWithCollectionsStorageAdminUsersWithCollectionsGet(xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.getUsersWithCollectionsStorageAdminUsersWithCollectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin-only: Transfer ownership of all storage objects that share the given link_id to the user identified by owner_email. Creates the user if necessary.
         * @summary Transfer Owner By Link
         * @param {TransferOwnerByLinkRequest} transferOwnerByLinkRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferOwnerByLinkStorageAdminTransferOwnerByLinkPost(transferOwnerByLinkRequest: TransferOwnerByLinkRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferOwnerByLinkStorageAdminTransferOwnerByLinkPost(transferOwnerByLinkRequest, xAPIKEY, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StorageAdminApi.transferOwnerByLinkStorageAdminTransferOwnerByLinkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StorageAdminApi - factory interface
 */
export const StorageAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageAdminApiFp(configuration)
    return {
        /**
         * Deletes all storage objects older than a specified number of days.
         * @summary Admin Cleanup By Age
         * @param {CleanupByAgeRequest} cleanupByAgeRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupByAgeStorageAdminCleanupByAgePost(cleanupByAgeRequest: CleanupByAgeRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<CleanupResponse> {
            return localVarFp.adminCleanupByAgeStorageAdminCleanupByAgePost(cleanupByAgeRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes all storage objects within a specific collection.
         * @summary Admin Cleanup By Collection
         * @param {CleanupByCollectionRequest} cleanupByCollectionRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupByCollectionStorageAdminCleanupByCollectionPost(cleanupByCollectionRequest: CleanupByCollectionRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<CleanupResponse> {
            return localVarFp.adminCleanupByCollectionStorageAdminCleanupByCollectionPost(cleanupByCollectionRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Purges all storage objects owned by a specific user by their email.
         * @summary Admin Cleanup By User
         * @param {CleanupByUserRequest} cleanupByUserRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCleanupByUserStorageAdminCleanupByUserPost(cleanupByUserRequest: CleanupByUserRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<CleanupResponse> {
            return localVarFp.adminCleanupByUserStorageAdminCleanupByUserPost(cleanupByUserRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Find storage object by mac_job_id in metadata_json
         * @summary Admin Find Storage By Mac Job
         * @param {string} jobId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet(jobId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet(jobId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Manually trigger processing for a storage object (admin-only)
         * @summary Admin Trigger Processing
         * @param {number} objectId 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost(objectId, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get collections for a specific user or public collections
         * @summary Get Collections For User
         * @param {string | null} [userEmail] 
         * @param {boolean} [publicOnly] 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionsForUserStorageAdminCollectionsGet(userEmail?: string | null, publicOnly?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CollectionInfo>> {
            return localVarFp.getCollectionsForUserStorageAdminCollectionsGet(userEmail, publicOnly, xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all users who have collections in storage
         * @summary Get Users With Collections
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersWithCollectionsStorageAdminUsersWithCollectionsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserWithCollections>> {
            return localVarFp.getUsersWithCollectionsStorageAdminUsersWithCollectionsGet(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin-only: Transfer ownership of all storage objects that share the given link_id to the user identified by owner_email. Creates the user if necessary.
         * @summary Transfer Owner By Link
         * @param {TransferOwnerByLinkRequest} transferOwnerByLinkRequest 
         * @param {string} [xAPIKEY] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnerByLinkStorageAdminTransferOwnerByLinkPost(transferOwnerByLinkRequest: TransferOwnerByLinkRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.transferOwnerByLinkStorageAdminTransferOwnerByLinkPost(transferOwnerByLinkRequest, xAPIKEY, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorageAdminApi - object-oriented interface
 */
export class StorageAdminApi extends BaseAPI {
    /**
     * Deletes all storage objects older than a specified number of days.
     * @summary Admin Cleanup By Age
     * @param {CleanupByAgeRequest} cleanupByAgeRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCleanupByAgeStorageAdminCleanupByAgePost(cleanupByAgeRequest: CleanupByAgeRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).adminCleanupByAgeStorageAdminCleanupByAgePost(cleanupByAgeRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes all storage objects within a specific collection.
     * @summary Admin Cleanup By Collection
     * @param {CleanupByCollectionRequest} cleanupByCollectionRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCleanupByCollectionStorageAdminCleanupByCollectionPost(cleanupByCollectionRequest: CleanupByCollectionRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).adminCleanupByCollectionStorageAdminCleanupByCollectionPost(cleanupByCollectionRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Purges all storage objects owned by a specific user by their email.
     * @summary Admin Cleanup By User
     * @param {CleanupByUserRequest} cleanupByUserRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCleanupByUserStorageAdminCleanupByUserPost(cleanupByUserRequest: CleanupByUserRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).adminCleanupByUserStorageAdminCleanupByUserPost(cleanupByUserRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find storage object by mac_job_id in metadata_json
     * @summary Admin Find Storage By Mac Job
     * @param {string} jobId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet(jobId: string, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).adminFindStorageByMacJobStorageAdminFindByMacJobJobIdGet(jobId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manually trigger processing for a storage object (admin-only)
     * @summary Admin Trigger Processing
     * @param {number} objectId 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost(objectId: number, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).adminTriggerProcessingStorageAdminTriggerProcessingObjectIdPost(objectId, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get collections for a specific user or public collections
     * @summary Get Collections For User
     * @param {string | null} [userEmail] 
     * @param {boolean} [publicOnly] 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollectionsForUserStorageAdminCollectionsGet(userEmail?: string | null, publicOnly?: boolean, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).getCollectionsForUserStorageAdminCollectionsGet(userEmail, publicOnly, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all users who have collections in storage
     * @summary Get Users With Collections
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersWithCollectionsStorageAdminUsersWithCollectionsGet(xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).getUsersWithCollectionsStorageAdminUsersWithCollectionsGet(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin-only: Transfer ownership of all storage objects that share the given link_id to the user identified by owner_email. Creates the user if necessary.
     * @summary Transfer Owner By Link
     * @param {TransferOwnerByLinkRequest} transferOwnerByLinkRequest 
     * @param {string} [xAPIKEY] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public transferOwnerByLinkStorageAdminTransferOwnerByLinkPost(transferOwnerByLinkRequest: TransferOwnerByLinkRequest, xAPIKEY?: string, options?: RawAxiosRequestConfig) {
        return StorageAdminApiFp(this.configuration).transferOwnerByLinkStorageAdminTransferOwnerByLinkPost(transferOwnerByLinkRequest, xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }
}



